/* eslint-disable react/prop-types */
import React from 'react';

// * Exports icons as svg to be embeded into the front-end in a way that allows
// * said icons to change color dynamically, hence the "fill" prop on each.


export const PhoneIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 500 500"
    >

      <path fill={fill} d="M0 0 C1.36113755 0.77962046 2.71467322 1.57258711 4.0625 2.375 C4.67080658 2.71739212 5.27911316 3.05978424 5.90585327 3.41255188 C14.33957268 8.5594227 20.98488061 15.84423808 27.9140625 22.79296875 C29.34138395 24.21572078 30.76907405 25.63810306 32.19711304 27.06013489 C35.17909768 30.03321814 38.15538484 33.01186454 41.12792969 35.99438477 C44.91633063 39.7942654 48.72033967 43.57807188 52.52904701 47.35758495 C55.47886793 50.2889583 58.41921252 53.22969808 61.35697556 56.17315102 C62.75477634 57.571104 64.15563684 58.9660052 65.55974197 60.35762596 C76.77528081 71.48742863 87.78603807 82.67151611 88.4375 99.375 C87.85052626 114.40152767 78.72931537 124.18930249 68.4453125 134.25 C67.54755096 135.14114502 66.64978943 136.03229004 65.724823 136.95043945 C63.36653847 139.28944113 61.00216954 141.62202944 58.63409424 143.95111084 C55.27740509 147.25511493 51.93123238 150.56975023 48.58590698 153.88525391 C46.80954284 155.64463153 45.03010884 157.40091607 43.24734497 159.15380859 C42.44916351 159.94223145 41.65098206 160.7306543 40.82861328 161.54296875 C40.12358673 162.23672607 39.41856018 162.9304834 38.69216919 163.64526367 C36.60661355 165.85887941 36.10515755 166.96426871 35.7890625 170.0078125 C36.13119223 174.2208957 37.60103899 177.51108961 39.4375 181.25 C39.97334717 182.36048706 39.97334717 182.36048706 40.52001953 183.4934082 C49.08239568 200.82237703 60.63458499 216.6402312 73.0625 231.375 C73.92493653 232.41238035 74.78689844 233.45015543 75.6484375 234.48828125 C85.33582565 246.11314703 95.6336241 257.03007781 106.3125 267.75 C107.15224365 268.5944165 107.9919873 269.43883301 108.85717773 270.30883789 C129.78792327 291.1858141 154.00912132 308.39072871 180 322.375 C180.90073242 322.8687915 181.80146484 323.36258301 182.72949219 323.87133789 C183.5909082 324.32629639 184.45232422 324.78125488 185.33984375 325.25 C186.48827759 325.86488281 186.48827759 325.86488281 187.65991211 326.4921875 C190.68920654 327.60527851 192.84623059 327.66742247 196.0625 327.375 C198.37353026 325.90571968 198.37353026 325.90571968 200.34863281 323.72241211 C201.13675354 322.92415512 201.92487427 322.12589813 202.73687744 321.30345154 C203.57136414 320.42858597 204.40585083 319.5537204 205.265625 318.65234375 C206.14345642 317.75890762 207.02128784 316.8654715 207.92572021 315.94496155 C210.26055489 313.56570454 212.58240798 311.1752181 214.89764404 308.77697754 C218.13747399 305.42352084 221.3922577 302.0847894 224.65643311 298.75502014 C226.39033325 296.98478664 228.11615966 295.20659515 229.83233643 293.41917419 C239.61537904 283.39675403 250.06162701 275.46722336 264.5 274.8125 C283.03056335 275.49312496 295.3373299 290.32744595 307.57421875 302.55078125 C308.95549224 303.92561195 310.3369087 305.30029901 311.71846008 306.67485046 C314.59881141 309.54329456 317.47506926 312.41577231 320.34887695 315.29077148 C324.01002595 318.95212393 327.68476325 322.59950118 331.36316204 326.24351215 C334.21584906 329.07384133 337.05927744 331.91333707 339.90027809 334.75539207 C341.25048462 336.10325825 342.60388942 337.44792932 343.96069908 338.78914833 C365.27279315 359.87902472 365.27279315 359.87902472 365.4375 375.625 C365.18576884 391.70432763 355.72043155 402.19494019 344.80078125 413.0703125 C343.80401677 414.07165262 342.80762006 415.07335895 341.81156921 416.07540894 C339.73295458 418.16290082 337.64884408 420.24470461 335.56079102 422.32275391 C332.9110246 424.96104772 330.27742747 427.61484127 327.64803791 430.27342415 C325.5968334 432.34314668 323.53620807 434.4032926 321.47289085 436.46093369 C320.49918204 437.43449113 319.52848703 438.41107424 318.5611515 439.39096451 C310.41246157 447.63045196 301.84510425 454.53883479 290.75 458.25 C289.61949219 458.63929688 288.48898437 459.02859375 287.32421875 459.4296875 C269.60449616 464.56522387 247.90226837 462.38496579 230.0625 458.375 C229.32515625 458.21402832 228.5878125 458.05305664 227.828125 457.88720703 C168.43511233 444.56217984 111.26101681 409.15233683 65.0625 370.375 C64.02744261 369.51550593 62.99228193 368.65613624 61.95703125 367.796875 C55.18903511 362.15195691 48.64266325 356.3090076 42.203125 350.29296875 C40.17173216 348.39620892 38.12272307 346.52377575 36.046875 344.67578125 C31.35859804 340.49347954 26.97888964 336.31277133 22.9375 331.50390625 C20.59379529 328.84282486 18.08678577 326.36239465 15.5625 323.875 C11.17859777 319.5374299 7.05413125 315.07390604 3.0625 310.375 C2.19238281 309.38242187 1.32226562 308.38984375 0.42578125 307.3671875 C-7.45527914 298.3501184 -14.77131854 288.96655471 -21.9375 279.375 C-22.42637695 278.72354004 -22.91525391 278.07208008 -23.41894531 277.40087891 C-49.5123645 242.56518601 -71.72188586 204.05896382 -86.06494141 162.87695312 C-86.82908453 160.68586785 -87.61755604 158.50613384 -88.41796875 156.328125 C-94.69159786 138.64614266 -98.11369708 120.54921575 -98.1875 101.8125 C-98.208125 100.53052734 -98.22875 99.24855469 -98.25 97.92773438 C-98.29598695 86.54021678 -97.04168838 75.38128252 -91.8125 65.125 C-91.29429688 64.06796875 -90.77609375 63.0109375 -90.2421875 61.921875 C-85.04402435 53.13744698 -76.61522744 45.87908039 -69.4765625 38.67578125 C-68.6053476 37.7964946 -67.73413269 36.91720795 -66.83651733 36.01127625 C-65.00770752 34.16874468 -63.17741796 32.32768074 -61.34570312 30.48803711 C-59.48932277 28.62009509 -57.63742852 26.74768407 -55.79003906 24.87084961 C-53.09124498 22.12918331 -50.37925429 19.40119819 -47.6640625 16.67578125 C-46.85224518 15.84645584 -46.04042786 15.01713043 -45.20401001 14.16267395 C-33.37128879 2.37371848 -16.97967295 -7.19986132 0 0 Z " transform="translate(97.9375,50.625)"/>
      <path fill={fill} d="M0 0 C57.29253218 4.2056845 114.80115176 35.09169962 155.9453125 74.01953125 C156.94756282 74.9251594 157.95281787 75.82747249 158.9609375 76.7265625 C189.83189611 104.30864135 213.1061168 139.96673099 228.9453125 178.01953125 C229.2551709 178.74591797 229.5650293 179.47230469 229.88427734 180.22070312 C237.66595001 198.54515342 246.12738615 220.94114298 245.9453125 241.01953125 C241.37525055 241.88208122 236.80373223 242.73627683 232.23071289 243.58300781 C230.67755815 243.87177153 229.12481383 244.16275239 227.57250977 244.45605469 C225.33195426 244.87899101 223.09000881 245.29374219 220.84765625 245.70703125 C220.16195053 245.83827393 219.47624481 245.9695166 218.76976013 246.10473633 C214.44377562 246.89190891 210.33772978 247.13939255 205.9453125 247.01953125 C205.67436768 245.88862061 205.67436768 245.88862061 205.39794922 244.73486328 C194.06953945 197.72518307 175.44027987 151.03093546 139.796875 116.8359375 C137.9453125 115.01953125 137.9453125 115.01953125 135.8828125 112.39453125 C133.55033209 109.53536171 130.92521123 107.27560128 128.12109375 104.88671875 C126.72265401 103.68662145 125.34298999 102.46409612 123.98828125 101.21484375 C112.11469137 90.27207067 98.79604917 81.24586362 84.9453125 73.01953125 C84.31189941 72.63700195 83.67848633 72.25447266 83.02587891 71.86035156 C59.20366194 57.53404523 32.98279087 48.91288255 5.9453125 43.01953125 C5.19411133 42.85437012 4.44291016 42.68920898 3.66894531 42.51904297 C-0.23434947 41.66315044 -4.14249947 40.83362181 -8.0546875 40.01953125 C-3.35413714 0.03188343 -3.35413714 0.03188343 0 0 Z " transform="translate(266.0546875,-0.01953125)"/>
      <path fill={fill} d="M0 0 C30.24729367 2.13229715 60.29759678 15.29921769 84 34 C84.53786133 34.42361816 85.07572266 34.84723633 85.62988281 35.28369141 C104.83980255 50.60438025 120.09808488 68.50683916 132 90 C132.3398291 90.60183105 132.6796582 91.20366211 133.02978516 91.82373047 C137.72173244 100.22705069 141.21786015 108.89082984 144.3125 118 C144.63806885 118.9480249 144.9636377 119.8960498 145.29907227 120.87280273 C147.98974446 129.115478 149.5410078 137.471964 151 146 C146.12644198 146.86098253 141.25177286 147.71526111 136.37597656 148.56347656 C134.71908246 148.85267284 133.06250087 149.14366579 131.40625 149.43652344 C129.0190384 149.85830241 126.63075997 150.27350623 124.2421875 150.6875 C123.50757294 150.81874268 122.77295837 150.94998535 122.01608276 151.08520508 C117.96239474 151.78057275 114.11181361 152.13574075 110 152 C109.74347656 150.79988281 109.48695313 149.59976563 109.22265625 148.36328125 C103.51548508 123.00379153 92.53387932 101.16554017 75 82 C74.26136719 81.19046875 73.52273438 80.3809375 72.76171875 79.546875 C53.25913748 59.15295089 26.39527319 46.48238819 -1.1484375 41.578125 C-4 41 -4 41 -5 40 C-4.8025952 31.04436937 -3.24389618 22.09471757 -1.9375 13.25 C-1.75123047 11.96867187 -1.56496094 10.68734375 -1.37304688 9.3671875 C-0.91859746 6.24430437 -0.46086118 3.12194219 0 0 Z " transform="translate(258,102)"/>
    </svg>
  );
}

export const EmailIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 512 512"
    >

      <defs>
          <style>
            {`
              .cls-1{fill: '${fill}';opacity:0}
              .cls-2{opacity:.6}
              .cls-3{stroke:${fill};fill:${fill};stroke-miterlimit: 10;stroke-width: 10px;opacity:1}
            `}
          </style>
      </defs>
      <g id="icons" transform="translate(0 0)">
          <path fill={fill} id="letter" d="M467,61H45C20.218,61,0,81.196,0,106v300c0,24.72,20.128,45,45,45h422c24.72,0,45-20.128,45-45V106    
          C512,81.28,491.872,61,467,61z M460.786,91L256.954,294.833L51.359,91H460.786z M30,399.788V112.069l144.479,143.24L30,399.788z     
          M51.213,421l144.57-144.57l50.657,50.222c5.864,5.814,15.327,5.795,21.167-0.046L317,277.213L460.787,421H51.213z M482,399.787    
          L338.213,256L482,112.212V399.787z"  className="cls-3" data-name="letter"/>
      </g>
      
    </svg>
  );
}

export const PersonIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 40 36"
    >

    <path fill={fill} d="M14 0C8.47715 0 4 4.47715 4 10C4 15.5228 8.47715 20 14 20C19.5228 20 24 15.5228 24 10C24 4.47715 19.5228 0 14 0ZM8 10C8 6.68629 10.6863 4 14 4C17.3137 4 20 6.68629 20 10C20 13.3137 17.3137 16 14 16C10.6863 16 8 13.3137 8 10Z"/>
    <path fill={fill} d="M29.8168 10.4366C29.2542 10.1497 28.6316 10.0001 28 10.0001V6.00012C29.2632 6.00012 30.5084 6.29913 31.6338 6.8729C31.7577 6.93609 31.8798 7.00242 32 7.0718C32.9708 7.63228 33.8144 8.39138 34.4746 9.30111C35.2165 10.3234 35.7059 11.5069 35.9025 12.7547C36.0991 14.0025 35.9975 15.2792 35.6059 16.4801C35.2142 17.6811 34.5438 18.7722 33.6494 19.6643C32.7551 20.5563 31.6622 21.2239 30.4602 21.6123C29.3906 21.958 28.2617 22.0739 27.1471 21.9544C27.0091 21.9396 26.8714 21.9212 26.734 21.8992C25.4876 21.6994 24.3062 21.2076 23.2862 20.4638L23.2842 20.4623L25.6421 17.2311C26.1523 17.6034 26.7434 17.8495 27.367 17.9495C27.9907 18.0494 28.6291 18.0003 29.23 17.806C29.831 17.6118 30.3775 17.2781 30.8246 16.832C31.2718 16.386 31.607 15.8405 31.8028 15.24C31.9986 14.6396 32.0494 14.0013 31.9511 13.3774C31.8528 12.7535 31.6082 12.1618 31.2372 11.6506C30.8662 11.1395 30.3795 10.7234 29.8168 10.4366Z"/>
    <path fill={fill} d="M35.9962 36C35.9962 34.9499 35.7894 33.9101 35.3875 32.94C34.9857 31.9698 34.3967 31.0883 33.6542 30.3458C32.9117 29.6033 32.0302 29.0143 31.06 28.6125C30.0899 28.2106 29.0501 28.0038 28 28.0038V24C29.3642 24 30.7168 24.2326 32 24.6863C32.1991 24.7567 32.3966 24.8324 32.5922 24.9134C34.0481 25.5165 35.371 26.4004 36.4853 27.5147C37.5996 28.629 38.4835 29.9519 39.0866 31.4078C39.1676 31.6034 39.2433 31.8009 39.3137 32C39.7674 33.2832 40 34.6358 40 36H35.9962Z"/>
    <path fill={fill} d="M28 36H24C24 30.4772 19.5228 26 14 26C8.47715 26 4 30.4772 4 36H0C0 28.268 6.26801 22 14 22C21.732 22 28 28.268 28 36Z"/>

    </svg>
  );
}

export const NifIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 537 537"
    >

      <path fill={fill} d="M436.223 81.648c-4.796.015-9.597.014-14.406.006a8375.32 8375.32 0 0 0-28.373-.002c-11.09.017-22.181.019-33.277.015-19.78-.006-39.56.003-59.34.028-19.243.024-38.489.023-57.737.027-21.047.004-42.1-.017-63.158-.004l-6.736.004c-1.696.001-1.695.003-3.35.004-7.757.005-15.514.006-23.271.002a12188.4 12188.4 0 0 0-28.662.014h-.002c-4.88.01-9.745.022-14.6.017-4.517-.007-9.046-.012-13.586.002h-.008c-1.627.007-3.252.014-4.873.018-17.074-.07-34.081 2.672-48.525 16.144v.002l-.117.11c-.112.104-.22.213-.323.326l-.086.096c-10.32 11.302-16.964 25.53-17.152 41.525a5.358 5.358 0 0 0-.002.373l-.004-.094.028 3.106c-.018 3.532-.029 7.08-.016 10.644v.024c.013 3.262.014 6.528.006 9.797-.018 6.468-.017 12.933-.002 19.396.018 7.564.019 15.133.016 22.705-.007 13.519.002 27.035.027 40.553.024 13.133.037 26.264.027 39.39-.011 14.383-.017 28.77-.004 43.159l.004 4.605.004 2.291c.005 5.293.006 10.585.002 15.877a5798.39 5798.39 0 0 0 .014 19.56v.019c.008 2.677.014 5.356.02 8.037-.008 3.707-.015 7.433 0 11.175v.03l.017 3.293c-.093 15.95 4.52 31.296 16.144 43.758h.002l.11.117c.104.112.213.22.326.322l.096.086c13.696 12.508 29.741 17.247 47.29 17.147h.042a518.71 518.71 0 0 1 4.67-.01c4.435.019 8.873.023 13.314.01h.002c4.796-.015 9.597-.013 14.406-.004 9.46.017 18.919.016 28.375.002 11.09-.018 22.18-.02 33.276-.018 19.78.007 39.56-.003 59.34-.027 19.245-.024 38.49-.037 57.732-.028 21.053.012 42.106.018 63.162.004 2.248 0 4.492-.003 6.733-.004h.004c1.692 0 1.7-.002 3.35-.004 7.757-.005 15.515-.006 23.27-.002 9.548.005 19.097.005 28.651-.011h.014c4.88-.01 9.744-.025 14.596-.02 4.512.007 9.037.012 13.572-.002h.028c1.62-.007 3.245-.011 4.87-.015 17.075.07 34.082-2.675 48.526-16.147v-.002l.117-.11c.101-.093.198-.19.291-.29l.11-.12c.003-.003.009-.007.011-.011 10.342-11.326 16.996-25.591 17.157-41.625v-.179l-.03-2.997v-.112c.018-3.53.03-7.078.018-10.642v-.024c-.013-3.26-.013-6.527-.004-9.797.017-6.468.016-12.932.002-19.394v-.004c-.018-7.564-.02-15.13-.018-22.703a17513.1 17513.1 0 0 0-.027-40.553 15212.27 15212.27 0 0 1-.027-39.389v-.006c.012-14.38.017-28.764.004-43.15l-.004-4.603v-.01c-.001-.78-.005-1.533-.006-2.282v-.006c-.005-5.292-.006-10.585-.002-15.877.005-6.519.005-13.044-.012-19.574v-.002l-.021-8v-.021a1990.134 1990.134 0 0 0 0-11.223l-.016-3.293c.093-15.95-4.523-31.296-16.147-43.758h-.002l-.109-.117a5.333 5.333 0 0 0-.326-.322l-.096-.086C487.844 86.288 471.8 81.549 454.25 81.65h-.036c-1.551.01-3.11.011-4.673.008-4.436-.02-8.874-.024-13.315-.01zM91.815 120.576h.002l.002.002c1.528.005 3.056.007 4.584.006h.016c4.188-.01 8.376-.01 12.562-.002 4.597.009 9.19.009 13.78.006 8.981-.007 17.964-.005 26.947.004 10.561.01 21.12.014 31.68.013 18.803 0 37.608.005 56.412.02 18.313.014 36.627.024 54.943.023h6.844c20.935 0 41.87.005 62.804.014 7.386.003 14.77.003 22.153.004 9.081 0 18.161.003 27.24.012 4.636.005 9.277.012 13.924.011h.002c4.296 0 8.586-.002 12.873.004l4.705.008h.02c2.161-.002 4.308-.007 6.437-.002l1.96.006h.025c9.57.006 15.5 1.254 21.482 6.614 4.942 5.745 6.17 12.58 6.22 22.125v.037c-.008 1.28-.011 1.394-.018 2.768v.076c.008 3.313.015 6.615.008 9.908-.006 2.431-.012 4.868-.01 7.307v.002c.007 6.612.008 13.222-.002 19.83a13521.7 13521.7 0 0 0-.014 21.12v.003c0 12.537-.006 25.074-.022 37.611-.014 12.205-.023 24.41-.023 36.615v4.563c0 13.962 0 27.92-.01 41.883-.003 4.922-.007 9.845-.008 14.767v.002c0 6.046-.006 12.095-.014 18.143v.008l-.01 7.455v.014c.001 3.465.002 6.923-.004 10.375l-.006 3.14v.035c.018 11.416-.54 18.358-6.65 25.164-6.857 5.862-15.417 6.202-27.47 6.16-1.525-.005-3.056-.008-4.589-.006h-.01c-4.19.008-8.379.01-12.564.002-4.594-.01-9.185-.01-13.774-.006h-.006c-8.981.006-17.963.005-26.945-.004h-.008c-10.56-.011-21.118-.014-31.674-.014-18.803.001-37.608-.006-56.41-.021-18.315-.014-36.63-.022-54.945-.022h-6.844c-20.936.001-41.87-.003-62.805-.012-7.384-.003-14.768-.007-22.152-.008h-.002c-9.08 0-18.16-.007-27.24-.015-4.636-.004-9.274-.01-13.92-.01h-.006c-4.294.002-8.583.002-12.871-.004h-.01l-4.695-.006h-.02c-2.16.002-4.306.005-6.44 0h-.015c-.654-.002-1.3-.005-1.955-.006h-.01c-9.567-.007-15.502-1.256-21.482-6.612-4.944-5.746-6.171-12.58-6.221-22.126v-.022l.016-2.788v-.07c-.008-3.311-.012-6.615-.004-9.91.006-2.433.009-4.868.008-7.303v-.006a6898.61 6898.61 0 0 1 .002-19.83c.01-7.043.014-14.082.013-21.12v-.003c0-12.537.005-25.074.02-37.611.014-12.205.024-24.408.023-36.615v-4.565c0-13.96.005-27.922.014-41.883.003-4.923.003-9.844.004-14.765v-.002c0-6.048.004-12.094.011-18.14v-.001c.004-2.485.01-4.973.012-7.463v-.014c0-3.465-.002-6.922.004-10.373v-.012l.008-3.129v-.036c-.017-10.744.445-17.263 5.66-24.1 6.667-6.914 15.673-7.268 28.457-7.224zm81.041 32.068-.004.002c-16.44-.493-33.066 5.558-45.404 18.834a5.064 5.064 0 0 0-.063.068l-.05.057a5.92 5.92 0 0 0-.07.08l-.05.057a5.742 5.742 0 0 0-.082.095c-10.228 12.446-16.471 27.236-15.703 44.27l.01.148.004.055.002.03.004.05.004.051.236 2.68c.94 12.437 6.826 23.951 13.742 32.937l.008.012.08.103c.104.134.214.262.33.385l.09.096.026.03c11.406 11.98 26.038 19.634 43.18 20.06l.128.002 2.758.023h.016a211.047 211.047 0 0 0 5.554-.008l.05-.002.048-.002c.02 0 .039 0 .058-.002 15.016-.782 28.82-8.053 38.684-18.717l.049-.054.053-.059c.063-.071.125-.144.185-.219l.033-.039.016-.021c11.074-13.596 16.483-29.198 15.318-46.967l-.002-.041c-.009-.15-.023-.3-.045-.45l-.006-.046-.175-1.307-.008-.058c-2.16-14.88-9.314-28.695-21.147-38.598a5.238 5.238 0 0 0-.05-.043l-.053-.043a5.402 5.402 0 0 0-.172-.135l-.055-.04a6.518 6.518 0 0 0-.053-.04l-1.08-.79-.045-.03c-10.838-7.752-23.561-12.03-36.35-12.414zm257.018 33.377c-.02 0-.04 0-.059.002l-3.412.043c-2.915-.01-5.843-.016-8.781-.006h-.012l-2.934.016h-.017c-1.728.014-3.457.023-5.196.029l-5.218.008c-2.93 0-5.856.006-8.784.014h-.01l-8.767.037h-.024c-5.098.032-10.193.056-15.287.068l-5.1.008c-3.655.002-7.309.007-10.964.014h-.004l-10.965.027h-.006c-2.089.008-4.178.014-6.267.018l-.004.002c-1.672.003-3.351.006-5.038.011h-.006l-5.02.024h-.028l-3.702.025-.004.002h-3.527l-3.18.031c-4.476.024-9.106 1.034-12.617 4.26v.002c-3.337 3.068-4.719 6.898-5.875 10.367l-.125.375a5.334 5.334 0 0 0-.277 1.696v.406c0 2.357.223 4.712 1.01 7.06v.002c.777 2.317 1.944 4.217 3.16 5.996l.004.004v.002l.234.344c.34.498.76.935 1.246 1.293l.34.25c1.845 1.36 3.995 3.05 7.172 3.855 2.887.732 5.474.632 9.203.66h.098c.025 0 .05 0 .076-.002l3.416-.048c3.885.008 7.799.012 11.732-.024l5.225-.033c1.735-.008 3.47-.012 5.213-.014l.004-.002a3126.85 3126.85 0 0 0 17.592-.062l6.236-.04c6.23-.033 12.463-.054 18.697-.066h.004l8.713-.021h.002l8.715-.031 4.19-.016c4.055-.015 8.119-.03 12.187-.055l3.703-.025.004-.002 3.477-.012h.057l3.195-.025.006-.002a96.356 96.356 0 0 0 5.404-.17l.508-.031a5.334 5.334 0 0 0 2.05-.55l.456-.226c.003 0 .007-.003.01-.004 1.307-.654 3.492-1.711 5.324-3.85h.002c1.553-1.812 2.484-3.643 3.986-6.296l.002-.002.262-.463a5.32 5.32 0 0 0 .666-2.115l.05-.53c.266-2.756.31-5.53-.46-8.4v-.002c-.672-2.505-1.847-4.635-3.152-6.59a4.98 4.98 0 0 0-.034-.047l-.506-.74a5.195 5.195 0 0 0-.039-.056l-.138-.198a5.334 5.334 0 0 0-.635-.748l-.172-.168-.02-.02-.54-.523-.014-.011c-1.366-1.312-3.588-3.22-6.705-4.03-1.582-.41-3.055-.526-4.532-.593h-.002c-1.488-.068-3.204-.082-5.36-.102h-.057zm-256.286 3.322c.914.008 1.854.073 2.8.153 7.703 2.365 12.644 5.734 16.447 12.279 3.207 7.574 3.276 13.686.468 21.516-2.839 5.321-8.002 9.622-14.08 12.07-6.75 2.035-11.836 1.376-18.806-1.717-6.864-4.848-10.214-10.015-12.12-18.293-.492-7.033 1.548-12.44 6.135-18.664 5.24-5.195 11.599-7.411 19.156-7.344zm256.286 60.678c-.02 0-.04 0-.059.002l-3.412.043c-2.915-.01-5.843-.016-8.781-.006h-.012l-2.934.016h-.017c-1.728.014-3.457.023-5.196.029l-5.218.008c-2.93 0-5.856.006-8.784.014h-.01l-8.767.037h-.024c-5.098.032-10.193.06-15.287.068l-5.1.008c-3.655.002-7.309.007-10.964.014h-.004l-10.965.027h-.006c-2.089.008-4.178.014-6.267.018l-.004.002c-1.672.003-3.351.006-5.038.011h-.006l-5.02.024h-.028l-3.702.025-.004.002h-3.527l-3.18.031c-4.476.024-9.106 1.034-12.617 4.26v.002c-3.337 3.068-4.719 6.898-5.875 10.367l-.125.375a5.334 5.334 0 0 0-.277 1.696v.406c0 2.357.223 4.712 1.01 7.06v.002c.777 2.317 1.944 4.217 3.16 5.996l.004.004v.002l.234.344c.34.498.76.935 1.246 1.293l.34.25c1.845 1.36 3.995 3.05 7.172 3.855 2.887.732 5.474.632 9.203.66h.098c.025 0 .05 0 .076-.002l3.416-.048c3.885.008 7.799.012 11.732-.024l5.225-.033c1.735-.008 3.47-.012 5.213-.014l.004-.002c5.862-.005 11.727-.024 17.592-.062l6.236-.04c6.23-.033 12.463-.054 18.697-.066h.004l8.713-.021h.002l8.715-.031 4.19-.016c4.055-.015 8.119-.03 12.187-.055l3.703-.025.004-.002 3.477-.012h.057l3.195-.025.006-.002a96.356 96.356 0 0 0 5.404-.17l.508-.031a5.334 5.334 0 0 0 2.05-.55l.456-.226c.003 0 .007-.003.01-.004 1.307-.654 3.492-1.711 5.324-3.85h.002c1.553-1.812 2.484-3.643 3.986-6.296l.002-.002.262-.463a5.32 5.32 0 0 0 .666-2.115l.05-.53c.266-2.756.31-5.53-.46-8.4v-.002c-.672-2.505-1.847-4.635-3.152-6.59a4.98 4.98 0 0 0-.034-.047l-.506-.74a5.195 5.195 0 0 0-.039-.056l-.138-.198a5.334 5.334 0 0 0-.635-.748l-.172-.168-.02-.02-.54-.523-.014-.011c-1.366-1.312-3.588-3.22-6.705-4.03-1.582-.41-3.055-.526-4.532-.593h-.002c-1.488-.068-3.204-.082-5.36-.102h-.057zm-255.914 25.17c-5.902-.193-11.865.104-17.862.828a4.275 4.275 0 0 0-.133.018l-.054.008-.059.01-.05.008-.036.006c-18.107 2.973-37.247 12.632-49.072 27.812a5.36 5.36 0 0 0-.162.207l.072-.098-1.197 1.58c-7.305 8.443-12.85 17.965-16.668 28.399l-.012.03-.328.913a5.312 5.312 0 0 0-.096.278l-.013.043-.006.02c-1.564 4.982-3.419 11.809-4.28 18.925-.848 7.01-.98 14.888 2.489 21.824l.195.39c.273.55.64 1.047 1.082 1.472l.314.3.01.008.85.809.012.012c2.035 1.926 4.696 4.173 8.48 5.127 1.998.504 3.953.642 6.072.703 2.124.061 4.636.033 7.83.004h.057c1.34-.014 2.684-.02 4.031-.02 3.776.011 7.553.005 11.33-.017h.002c3.97-.025 7.946-.034 11.928-.036l.004-.002c6.689-.004 13.38-.016 20.074-.046l12.955-.051c4.316-.013 8.636-.02 12.954-.026h.002l11.236-.017h.002c3.745-.007 7.494-.015 11.24-.024h.002l4.783-.013.004-.002c4.618-.01 9.243-.018 13.875-.04h.03l4.222-.019.004-.002 3.987-.008h.045l3.621-.023h.026c2.416-.01 4.998-.024 7.822-.694 2.922-.691 5.718-2.089 8.348-4.097l.004-.004.25-.192c.354-.27.673-.585.949-.935l.193-.246.002-.002c1.628-2.067 3.07-4.296 3.834-7 .744-2.632.702-4.98.668-7.125 0-.055-.002-.11-.004-.164l-.002-.043-.002-.043c0-.007-.003-.013-.004-.02l-.103-2.047v-.015l-.006-.114c-.283-13.521-3.23-27.144-9.885-39.488a5.333 5.333 0 0 0-.153-.28l-.01-.011-1.367-2.373.026.047c-4.082-7.248-8.746-13.518-14.696-19.377l-.04-.04-1.14-1.097a5.5 5.5 0 0 0-.105-.097l-.045-.041-.017-.018-2.496-2.258-.004-.002a145.325 145.325 0 0 0-4.221-3.709l-.022-.02-.004-.003-.03-.028a6.503 6.503 0 0 0-.052-.04 5.365 5.365 0 0 0-.336-.276l-.06-.045-.026-.02-.91-.666-.021-.013c-15.248-11.046-32.422-16.115-50.127-16.694zM172.252 312c10.795.08 21.699 3.58 31.409 10.68 8.238 6.846 13.486 15.233 16.207 24.985H123.44c2.226-7 5.625-13.38 10.432-19.014 10.77-11.234 24.487-16.754 38.38-16.65zm257.622 2.02c-.02 0-.04 0-.059.002l-3.412.043c-2.915-.01-5.843-.016-8.781-.006h-.012l-2.934.016h-.017c-1.728.014-3.457.023-5.196.029l-5.218.008c-2.93 0-5.856.006-8.784.014h-.01l-8.767.037h-.024c-5.098.032-10.193.056-15.287.068l-5.1.008c-3.655.002-7.309.007-10.964.014h-.004l-10.965.027h-.006c-2.089.008-4.178.014-6.268.018l-.004.002c-1.671.003-3.35.006-5.037.011h-.006l-5.02.024h-.028l-3.702.025-.004.002h-3.527c-1.086.01-2.135.022-3.18.031-4.476.024-9.106 1.034-12.617 4.26v.002c-3.337 3.068-4.719 6.898-5.875 10.367l-.125.375a5.334 5.334 0 0 0-.277 1.696v.406c0 2.357.223 4.712 1.01 7.06v.002c.777 2.317 1.944 4.217 3.16 5.996l.004.004v.002l.234.344c.34.498.76.935 1.246 1.293l.34.25c1.845 1.36 3.995 3.05 7.172 3.855 2.887.732 5.474.632 9.203.66h.098c.025 0 .05 0 .076-.002l3.416-.048c3.885.008 7.799.012 11.732-.024l5.225-.033c1.735-.008 3.47-.012 5.213-.014l.004-.002c5.862-.005 11.727-.024 17.592-.062l6.236-.04c6.23-.033 12.463-.054 18.697-.066h.004l8.713-.021h.002l8.715-.031 4.19-.016c4.055-.015 8.119-.03 12.187-.055l3.703-.025.004-.002 3.477-.012h.057l3.195-.025.006-.002a96.356 96.356 0 0 0 5.404-.17l.508-.031a5.334 5.334 0 0 0 2.05-.55l.456-.226c.003 0 .007-.003.01-.004 1.307-.654 3.492-1.711 5.324-3.85h.002c1.553-1.812 2.484-3.643 3.986-6.296l.002-.002.262-.463a5.32 5.32 0 0 0 .666-2.115l.05-.53c.266-2.756.31-5.53-.46-8.4v-.002c-.672-2.505-1.847-4.635-3.153-6.59a4.98 4.98 0 0 0-.033-.047l-.506-.74a4.376 4.376 0 0 0-.039-.056l-.138-.198a5.334 5.334 0 0 0-.635-.748l-.172-.168-.02-.02-.54-.523-.014-.011c-1.366-1.312-3.588-3.22-6.705-4.03-1.582-.41-3.055-.526-4.532-.593h-.002c-1.488-.068-3.204-.082-5.36-.102h-.057z" overflow="visible"/>

    </svg>
  );
}

export const BusinessIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 573 570"
    >

      <path fill={fill} d="M67.377 16.004c-10.875.11-22.87 3.186-33.092 12.139l-.006.005-.43.38-.398.42-.01.01c-11.599 12.358-12.002 27.59-11.935 39.55v.051c.01 1.807.015 3.615.012 5.425-.018 5.1-.02 10.2-.004 15.303v.028c.017 5.532.016 11.072.01 16.623-.014 10.908-.009 21.814.01 32.718.02 12.786.025 25.575.025 38.368-.002 24.175.016 48.348.046 72.521.028 21.506.043 43.011.041 64.516v6.22l-.001 10.328v2.06c-.002 21.245.012 42.487.027 63.728.006 8.947.009 17.895.01 26.843 0 11.015.006 22.032.023 33.051v.002c.01 5.623.022 11.238.022 16.84-.003 5.207-.003 10.422.01 15.644v.026c.005 1.892.01 3.782.013 5.674-.005 2.593-.011 5.209-.002 7.85v.041l.012 2.242c-.067 11.72 3.823 22.744 11.865 31.69l.354.396.378.35.006.006.006.004c12.42 11.59 27.562 12.094 39.737 12.027h.023c1.818-.011 3.636-.015 5.457-.012 5.157.018 10.316.023 15.48.008h.003c5.582-.018 11.173-.019 16.769-.012 11.002.014 22.003.01 33.004-.01 12.898-.02 25.8-.028 38.703-.027 24.386.002 48.77-.014 73.154-.045 21.694-.027 43.386-.042 65.078-.04h18.77c21.428 0 42.855-.011 64.28-.026h.007c9.027-.006 18.052-.01 27.076-.012 11.112 0 22.225-.007 33.34-.023h.002c5.67-.01 11.332-.018 16.985-.018 5.254.002 10.515 0 15.785-.012h.027c1.89-.006 3.783-.01 5.68-.013 2.64.004 5.302.009 7.986 0h.018l2.26-.012c11.723.066 22.774-3.791 31.752-11.863l.015-.014.381-.346.342-.367.008-.006c8.08-8.65 11.932-19.734 12.047-30.94v-.271c-.016-1.28-.02-1.399-.033-2.529v-.068c.013-3.02.02-6.063.004-9.133v-.052c-.014-2.21-.02-4.419-.02-6.629v-.008c.01-6.113.006-12.228-.017-18.348v-.033a5464.52 5464.52 0 0 1-.037-19.425c-.004-11.575-.022-23.152-.055-34.727a15494.08 15494.08 0 0 1-.067-35.856v-.006l-.006-8.388c-.007-10.79-.022-21.576-.039-32.362l-.017-11.675c-.008-6.227-.018-12.458-.036-18.692v-.027l-.02-6.836v-.016c-.003-3.19-.007-6.388-.019-9.595v-.038l-.011-2.83v-.017c0-9.05-1.71-17.816-6.875-26.365l-.01-.016-.346-.566-.404-.532-.014-.015c-10.413-13.488-25.336-17.044-37.56-19.377l-.026-.004-.055-.01a1416.78 1416.78 0 0 1-8.226-1.547l-.022-.004c-3.098-.6-6.196-1.202-9.295-1.8l-.02-.005-.733-.14h.019a2951.915 2951.915 0 0 1-27.256-5.356l-2.103-.426-8.584-1.732c-8.145-1.647-16.287-3.284-24.428-4.918-9.157-1.839-18.31-3.678-27.461-5.524a18078.17 18078.17 0 0 0-20.656-4.156 6257.2 6257.2 0 0 1-10.819-2.174h-.004l-.722-.146a4017.532 4017.532 0 0 0-9.492-1.912l-3.551-.71-.149-.03-.048-.01c-4.68-.954-9.448-1.728-14.284-2.39.032-12.358.06-24.716.077-37.077.01-7.746.022-15.488.044-23.225v-.025c.02-6.798.037-13.602.043-20.41v-.008c.002-3.596.003-7.18.016-10.748v-.033c.014-3.43.026-6.869.025-10.322l-.002-3.768v-.021c.064-10.792-.774-22.234-8.656-33.428l-.008-.012-.246-.347-.271-.334-.014-.016c-10.327-12.573-24.94-16.316-37.285-18.128l-.135-.03-.35-.039a875.73 875.73 0 0 1-5.912-.816l-.015-.002a3471.94 3471.94 0 0 0-9.19-1.318c-7.754-1.1-15.533-2.287-23.351-3.485h-.002c-4.852-.744-9.703-1.482-14.551-2.22l-6.092-.928c-13.137-2-26.272-3.997-39.406-5.992-11.56-1.757-23.12-3.514-34.678-5.276-10.27-1.566-20.542-3.131-30.816-4.691h-.002c-5.412-.821-10.819-1.64-16.221-2.465l-.604-.092c-4.93-.753-9.864-1.506-14.8-2.254h-.002l-5.67-.859-.016-.002c-8.938-1.373-18.832-3.6-29.574-3.492Zm2.832 46.014c.496-.026 2.527.328 8.443 1.513l.018.004.24.047 3.569.566.03.004.067.012c3.195.49 6.377.978 9.547 1.473a4689.8 4689.8 0 0 0 12.818 1.986l.024.004-.022-.002.602.092 3.898.601h.002l2.3.352-.005-.002a11398.688 11398.688 0 0 0 56.037 8.518h.002l.588.087c10.706 1.606 21.41 3.218 32.12 4.832 10.232 1.543 20.468 3.087 30.708 4.621 8.423 1.263 16.841 2.526 25.258 3.797 4.405.666 8.818 1.334 13.242 1.994h.004l.584.088h.002c3.948.59 7.889 1.18 11.823 1.776l-.004-.002 3.884.59.586.195h.717l3.735.553 3.209.49.015.006.684.103c3.174.478 3.92.74 4.435.969.077.14.11.53.145.83l-.004 2.748v.094c.014 2.28.022 4.525.008 6.734a589.07 589.07 0 0 0-.016 5.162v.03c.014 4.645.012 9.288-.008 13.928-.022 5.134-.024 10.257-.021 15.371.005 8.829-.002 17.658-.024 26.484-.032 12.91-.05 25.82-.054 38.729-.008 20.893-.031 41.785-.069 62.678a64541.26 64541.26 0 0 0-.086 61.138v.002c0 1.928 0 1.922-.002 3.805v.01l-.015 18.941c-.04 49.533-.109 99.067-.19 148.602h-39.086c-.034-6.661-.066-13.321-.115-19.994v-.002c-.053-7.007-.11-14-.144-20.979v-.036a5122.17 5122.17 0 0 0-.104-17.486v-.07c-.02-2.199-.038-4.396-.055-6.592v-.04c-.009-3.163-.019-6.35-.048-9.562v-.088c-.015-1.443-.018-1.539-.032-2.853.015-12.254-2.441-25.712-12.724-36.555l-.217-.227-.23-.22-.003-.002c-12.566-11.919-27.972-12.739-40.748-12.641h-.033c-1.558.013-3.112.022-4.662.025-3.32.002-6.652.007-9.996.026h-.014c-4.28.028-8.548.051-12.802.056-4.185.004-8.369.015-12.551.03l-2.39.01c-2.294.005-4.597.01-6.915.025h-.016c-1.07.008-1.057.01-2.097.016-11.72.065-24.368 3.058-34.451 12.47l-.01.008-.582.55-.493.599v.002l-.008.008c-7.475 9.106-10.764 19.872-10.923 30.945l-.002.059v.125c0 .957.002 1.881.003 2.795-.031 3.117-.06 6.251-.07 9.404v.027c-.006 2.217-.019 4.435-.035 6.657-.05 5.902-.091 11.81-.117 17.718-.027 6.089-.065 12.18-.11 18.276-.068 9.192-.12 18.385-.17 27.578-2.606.013-5.215.03-7.818.04-3.345.01-6.71.017-10.088.038h-.008c-3.27.022-6.535.04-9.794.049-1.279.003-2.515.009-3.747.012h-.074l-3.648.029h-3.348c-.713.003-.636.03-.976.05.024-.276.048-.206.04-.884l.02-1.697.004-.067v-.324c-.012-2.438-.02-4.85-.01-7.238v-.006c.009-1.83.012-3.657.01-5.485v-.027c-.012-4.97-.013-9.94 0-14.908.014-5.473.016-10.942.012-16.404-.009-10.675-.004-21.35.011-32.027.019-12.557.025-25.114.026-37.666.001-23.01.014-46.018.039-69.028.023-21.78.04-43.561.043-65.344v-2.036l.002-8.12v-8.095c.003-20.811.015-41.625.027-62.44.005-7.524.007-15.05.01-22.573.004-12.056.012-24.11.025-36.162v-.012c.007-5.506.014-11.018.016-16.532 0-5.115.002-10.225.01-15.33v-.015l.01-5.553v-.024c-.002-2.576-.004-5.14.002-7.69v-.021l.007-2.28v-.062c-.003-1.29.023-1.485.041-2.09.559-.154 2.214-.691 2.282-.695zm45.758 94.98h.002l.002.139zm0 64h.002l.002.139zm229.05 34.09c14.535 2.736 29.062 5.465 43.524 8.336v-.002l7.865 1.56c6.286 1.246 12.572 2.492 18.858 3.74 6.41 1.274 12.822 2.547 19.236 3.817a34730.494 34730.494 0 0 1 25.012 4.961h.004a4076.2 4076.2 0 0 1 21.953 4.389c3.714.756 7.45 1.499 11.215 2.213l.021.004.098.019c2.54.477 5.086.969 7.644 1.47l3.764.741.018.004.074.014.092.017c1.202.217 2.371.43 3.543.64l.011.003 2.819.568.138.04.403.068c.882.16 1.123.125 1.175.07.032.054.095.138.211.266.002.22-.032.86-.023 2.084v.021c0 .094-.003.056-.002.158l-.037 2.405v.15c.018 2.91.027 5.789.008 8.639a789.935 789.935 0 0 0-.022 6.533v.03c.016 5.827.015 11.65-.011 17.47a4282.95 4282.95 0 0 0-.04 18.721c0 11.073-.018 22.145-.056 33.217-.037 10.802-.064 21.61-.068 32.422v4.035c-.003 12.334-.018 24.67-.041 37.006-.007 3.732-.014 7.466-.018 11.203v.01a6261.968 6261.968 0 0 1-.06 24.476v.047c-.001 3.066-.004 6.116-.018 9.15l-.016 2.762v.1c.006 2.128-.018 3.401-.082 4.352-.247-.022-.188-.048-.576-.051l-1.871-.024-.072-.006h-.297c-2.4.008-4.774.013-7.121-.002a925.837 925.837 0 0 0-5.432-.02h-.016c-4.85.005-9.695 0-14.535-.02h-.002a3138.38 3138.38 0 0 0-11.49-.032c-8.549-.006-8.557-.006-17.092-.015h-.024c-9.84-.029-19.39-.053-28.941-.08h-.027l-79.696-.165zm-229.05 29.91h.002l.002.139zm396.564 2.738c.096.079.14.092.157.172zm-396.564 61.262h.002l.002.139zm41.533 71.063c1.21.01 3.034.08 5.633.158l.117.004.125.002c1.426.013 2.848.02 4.266.023h.02c2.903.002 5.793.007 8.668.026 3.787.028 7.592.053 11.414.058 2.953.004 5.9.01 8.843.02l4.237.017h.015c1.358.004 2.711.007 4.057.012l3.81.03h.032c2.56.015 4.032.09 4.654.19.689 1.658.984 2.972 1 5.919v.045l-.03 2.373-.001.05v.105c0 2.928-.002 5.835-.024 8.724-.016 2.116-.027 4.23-.033 6.342v.029c-.008 5.48-.026 10.956-.058 16.43-.041 6.84-.063 13.67-.08 20.494-.039 10.73-.063 15.275-.094 21.46h-61.106c-.032-6.503-.068-13.007-.086-19.5v-.02c-.017-6.893-.03-13.804-.066-20.729v-.048c-.033-5.748-.063-11.483-.074-17.211v-.014a5308.38 5308.38 0 0 0-.014-6.563v-.079c-.023-3.152-.047-6.275-.049-9.372v-.004l.002-2.894v-.338c-.028-2.402-.022-3.955.055-4.787 1.71-.7 2.588-.97 4.768-.952z" overflow="visible"/>
      <rect width="88.566" height="44.499" x="388.272" y="312.503" fill={fill} ry="20.394"/>
      <rect width="88.566" height="44.499" x="388.272" y="375.492" fill={fill} ry="20.394"/>
      <rect width="88.566" height="44.499" x="385.828" y="439.492" fill={fill} ry="20.394"/>
      <g fill={fill} transform="translate(16 10)">
        <rect width="88.566" height="44.499" x="69.772" y="302.344" ry="20.394"/>
        <rect width="88.566" height="44.499" x="175.772" y="301.671" ry="20.394"/>
      </g>
      <g fill={fill} transform="translate(16 -55.415)">
        <rect width="88.566" height="44.499" x="69.772" y="302.344" ry="20.394"/>
        <rect width="88.566" height="44.499" x="175.772" y="301.671" ry="20.394"/>
      </g>
      <g fill={fill} transform="translate(16 -118.694)">
        <rect width="88.566" height="44.499" x="69.772" y="302.344" ry="20.394"/>
        <rect width="88.566" height="44.499" x="175.772" y="301.671" ry="20.394"/>
      </g>
      <g fill={fill} transform="translate(16 -182.177)">
        <rect width="88.566" height="44.499" x="69.772" y="302.344" ry="20.394"/>
        <rect width="88.566" height="44.499" x="175.772" y="301.671" ry="20.394"/>
      </g>

    </svg>
  );
}

export const AutoParticularesIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 25 14.18"
    >

  <g id="layer1" transform="translate(-199.109 -123.712)">
    <g id="g43175-9-23-3" fill={fill} transform="translate(149.928 107.046) scale(.18268)">
      <path id="path43145-4-1-46" fill={fill} strokeWidth=".449" d="M320.62 107.742c-3.372.25-6.645 1.201-9.74 2.531-6.25 2.523-12.526 4.984-18.759 7.546-3.344 1.427-5.8 4.67-6.332 8.258-.275 2.545-.076 5.118-.137 7.675.032 2.88-.062 5.77.047 8.644.127 1.12 1.369 1.56 2.358 1.41h9.43c.59 2.938 2.414 5.626 5.018 7.134 3.043 1.858 7.042 1.983 10.208.348 2.763-1.377 4.821-4.027 5.532-7.027-.026-.698.718-.396 1.194-.454h38.041c.594 2.973 2.46 5.68 5.104 7.187 3.034 1.804 6.986 1.915 10.123.293 2.762-1.377 4.82-4.027 5.53-7.026-.025-.698.718-.396 1.195-.454 2.925-.031 5.86.062 8.778-.048 1.071-.124 1.555-1.292 1.41-2.26-.051-2.883.114-5.776-.11-8.652-.492-3.85-2.813-7.424-6.177-9.375-2.282-1.454-5.021-1.74-7.64-2.104-3.374-.51-6.774-.948-10.132-1.505-6.251-3.157-12.47-6.38-18.74-9.495-4.022-1.958-8.525-2.804-12.983-2.706-4.406.04-8.816-.087-13.219.08zm2.095 3.338h10.676v8.77h-18.772l6.703-8.743c.465 0 .929-.02 1.393-.027zm14.19.066c3.038.287 6.024 1.093 8.766 2.442 4.09 2.058 8.173 4.139 12.245 6.234-7.049.032-14.099.005-21.148.014.007-2.9.015-5.8.021-8.701l.1.01zm-20.659.971-5.918 7.733c-4.602-.017-9.208.032-13.808-.025-.094-.192.994-.463 1.366-.663 5.671-2.253 11.311-4.591 17.002-6.792.521-.18 1.046-.35 1.569-.526l-.21.273zm-18.992 11.113c22.61.01 45.222-.019 67.83.015l9.254 1.345c.264 2.26 1.148 4.44 2.592 6.204a11.739 11.739 0 0 0 6.946 4.065c.776.135 1.574.184 2.362.196v5.375h-7.793c-.398-2.508-1.664-4.96-3.66-6.599-2.378-2.063-5.722-2.938-8.81-2.334-2.628.467-5.025 2.01-6.605 4.156-1.021 1.405-1.674 3.09-1.944 4.777h-38.989c-.41-2.539-1.658-4.962-3.654-6.612-2.379-2.07-5.728-2.947-8.82-2.343-2.63.47-5.034 2.013-6.607 4.17-1.029 1.404-1.665 3.098-1.946 4.785h-8.353v-7.284c1.853.088 3.835-.115 5.338-1.306 1.902-1.32 2.88-3.688 2.753-5.97v-2.64h.1zm-6.647.01h3.127c-.068 1.395.158 2.827-.157 4.194-.43 1.485-1.976 2.432-3.49 2.305-.532-.014-1.307.216-1.03-.606-.089-1.9.12-3.901 1.24-5.502.098-.11.155-.366.31-.39zm87.368 1.893c2.789.403 5.387 2.039 6.843 4.467.41.66.719 1.382 1 2.105-2.03-.12-4.042-.854-5.53-2.269-1.248-1.152-2.05-2.704-2.483-4.334l.098.018zm-70.485 9.549c2.074-.094 4.185.688 5.611 2.213 1.8 1.823 2.48 4.668 1.68 7.107-.72 2.45-2.87 4.4-5.372 4.903-2.485.552-5.244-.353-6.892-2.304-1.53-1.692-2.11-4.145-1.606-6.361.498-2.085 1.943-3.92 3.885-4.842.842-.416 1.764-.618 2.694-.716zm60.008 0c2.075-.095 4.186.688 5.614 2.212 1.797 1.824 2.482 4.67 1.68 7.108-.722 2.448-2.87 4.398-5.371 4.902-2.484.552-5.242-.351-6.89-2.3-1.505-1.663-2.106-4.074-1.625-6.262.482-2.262 2.125-4.234 4.267-5.108.749-.317 1.521-.462 2.325-.552z"/>
      <path id="path43147-2-3-5" fill={fill}  strokeWidth=".449" d="M330.11 130.576c-1.015.398-1.11 1.975-.11 2.441 1.021.366 2.17.095 3.243.178 3.9-.013 7.804.026 11.7-.02 1.163-.014 1.707-1.654.792-2.36-.857-.624-2.002-.24-2.99-.346-4.066.013-8.137-.027-12.2.02l-.436.087z" />
      <path id="path43149-4-2-0" fill={fill} strokeWidth=".449" d="M367.232 139.578c-1.463.416-2.188 2.333-1.302 3.583.808 1.394 3.023 1.452 3.924.123.957-1.205.363-3.19-1.103-3.663-.49-.204-1.012-.144-1.519-.043z" />
      <path id="path43151-0-1-57" fill={fill} strokeWidth=".449" d="M307.219 139.578c-1.496.427-2.213 2.43-1.237 3.665.837 1.333 2.987 1.328 3.866.037.951-1.208.356-3.19-1.11-3.66-.493-.204-1.01-.146-1.52-.042z" />
    </g>
  </g>

    </svg>
  );
}

export const WorkAccidentIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19.9 19"
    >

      <g id="layer1" transform="translate(-696.843 -120.802)">
          <g fill={fill} transform="matrix(.0859 0 0 .0859 697.265 121.138)">
            <path id="path828-5" fill={fill} d="M70.94 128.078a5.12 5.12 0 0 1 3.7 1.58 2.83 2.83 0 0 0 4.06 0 3 3 0 0 0 0-4.17 10.75 10.75 0 0 0-15.52 0 3 3 0 0 0 0 4.17 2.81 2.81 0 0 0 4 0 5.14 5.14 0 0 1 3.71-1.58"/>
            <path id="path830-5" fill={fill} d="M122.54 125.498a3 3 0 0 0 0 4.17 2.81 2.81 0 0 0 4.05 0 5.15 5.15 0 0 1 7.41 0 2.81 2.81 0 0 0 4 0 3 3 0 0 0 0-4.17 10.75 10.75 0 0 0-15.51 0" />
            <path id="path832-1" fill={fill} d="M130.28 154.598a41.14 41.14 0 0 1-59.32 0 2.82 2.82 0 0 0-4.06 0 3 3 0 0 0 0 4.17 46.76 46.76 0 0 0 67.43 0 3 3 0 0 0 0-4.17 2.81 2.81 0 0 0-4 0" />
            <path id="path834-38" fill={fill} strokeWidth="1" d="M78.011 31.017a6.89 6.89 0 0 0-6.33 4.172A52.22 52.22 0 0 0 37.34 77.807l-.681 2.105a10.31 10.31 0 0 0 3.483 19.945h5.868v15.312a16.438 16.438 0 0 0 .902 32.327 57.266 57.266 0 0 0 15 29.774 53.174 53.174 0 0 0 38.658 16.72 53.507 53.507 0 0 0 38.657-16.493 56.38 56.38 0 0 0 15.183-30.001c8.017-1.198 13.926-8.122 13.842-16.228v-.008a16.263 16.263 0 0 0-13.002-16.092v-15.31h1.908a10.32 10.32 0 0 0 3.234-20.113 52.21 52.21 0 0 0-34.795-44.556 6.89 6.89 0 0 0-6.323-4.173zm-.045 6.86h41.308V68.88a3.45 3.45 0 0 0 6.883 0V42.792a45.35 45.35 0 0 1 27.276 36.415h-5.006a3.442 3.442 0 1 0 0 6.884h8.701a3.46 3.46 0 0 1 3.453 3.415 3.51 3.51 0 0 1-3.438 3.476H40.112a3.46 3.46 0 0 1-3.453-3.423 3.51 3.51 0 0 1 3.437-3.468h8.716a3.442 3.442 0 0 0 0-6.884h-5.005a45.35 45.35 0 0 1 27.276-36.415v26.087a3.45 3.45 0 0 0 6.883 0zM51.75 99.857h80.775c3.887 5.663 9.931 9.656 16.947 10.511v27.412a50.724 50.724 0 0 1-14.32 35.568l.016.03a47.813 47.813 0 0 1-34.545 14.743 47.608 47.608 0 0 1-34.584-15 51.633 51.633 0 0 1-14.289-35.916zm88.348 0h9.39v4.604c-3.619-.631-6.815-2.29-9.39-4.604zm15.1 21.362c9.791 3.169 9.719 17.051-.107 20.113.07-1.175.106-2.352.106-3.537zm-109.188.03v16c0 1.38.002 2.75.152 4.12a10.432 10.432 0 0 1-7.444-10.079v-.045a10.447 10.447 0 0 1 7.292-9.996z" />
          </g>
        </g>

    </svg>
  );
}

export const BikeIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 22 16.231"
    >

    <g fill={fill}>
      <path d="m17.63 8.667-.02-.01-.007-.02c-.368-1.031-1.72-1.258-2.286-1.306l-.044-.005v-.044a5.339 5.339 0 0 0-.269-1.417l-.013-.042.046-.024a.863.863 0 0 0 .058-.027l.015-.007a1.255 1.255 0 0 0 .115-.07l.01-.009a.957.957 0 0 0 .056-.042.725.725 0 0 0 .05-.045l.01-.01a.87.87 0 0 0 .044-.044l.008-.008.04-.048.01-.013.04-.054.003-.006a2.12 2.12 0 0 0 .033-.052l.007-.013a.725.725 0 0 0 .032-.061l.004-.008.023-.055.007-.015a.832.832 0 0 0 .04-.133c0-.006 0-.011.004-.016a.861.861 0 0 0 .013-.069v-.01l.006-.06v-.088a1.049 1.049 0 0 0-1.042-1.047h-.55l-.012-.037A1.05 1.05 0 0 0 13.048 3l-.778.006a.266.266 0 0 0-.262.265v.283l-1.836-.512a.266.266 0 0 0-.201.024.261.261 0 0 0-.127.16.264.264 0 0 0 .183.325l1.983.55.008.027a.266.266 0 0 0 .046.089c.42.524 1.509 2.08 1.509 2.967 0 .835-.457 1.972-1.194 2.352-.419.216-.874.152-1.353-.19-.48-.341-.782-.9-.852-1.582-.076-.737-.55-1.176-.932-1.414l-.037-.024.017-.04a.64.64 0 0 0 .053-.256V5.5a.644.644 0 0 0-.643-.643H6.107a.644.644 0 0 0-.643.644v.53a.643.643 0 0 0 .046.246l.019.046-.046.02c-1.55.704-2.43 3.003-2.466 3.101a.264.264 0 0 0 .129.33.275.275 0 0 0 .033.015l.672.259-.016.046a2.391 2.391 0 0 0 4.463 1.701l.015-.034h.959a.256.256 0 0 0 .05-.006h5.108l.014.032a2.39 2.39 0 1 0 3.186-3.12Zm-3.582-4.303.005-.045h.57a.52.52 0 0 1 .519.518.444.444 0 0 1 0 .053v.026l-.004.023-.005.02c0 .01-.005.02-.008.028l-.007.022c0 .01-.006.018-.009.026l-.014.029a.144.144 0 0 1-.009.018c0 .005-.007.013-.011.02l-.013.02-.014.02-.015.02-.014.017L15 5.2l-.016.016-.006.006-.014.012-.01.008-.013.01-.016.012-.018.012-.022.013c-.007.005-.015.008-.022.012l-.022.01-.024.01-.023.01-.024.006-.025.006-.023.005-.027.005h-.052c-.225-.048-.382-.147-.481-.304-.135-.209-.136-.487-.114-.684zM5.992 5.507a.116.116 0 0 1 .114-.115h2.528a.116.116 0 0 1 .115.115v.53a.116.116 0 0 1-.05.093l-.013.01H6.398c-.07 0-.138 0-.214.01h-.077a.116.116 0 0 1-.115-.114Zm1.804 6.119a1.862 1.862 0 0 1-3.467-1.334l.016-.053.789.304-.011.044a1.018 1.018 0 0 0 1.886.725l.021-.04.79.304zm-2.175-.797V10.8l.005-.069.91.35-.044.056a.49.49 0 0 1-.873-.307Zm2.779.398-.124-.047-.024-.008-3.974-1.526-.028-.013-.626-.241.022-.05a8.029 8.029 0 0 1 .682-1.222l.01-.013.015-.006c.365-.13 2.245-.734 3.479.119.76.525 1.157 1.52 1.178 2.958v.052zm5.848-.384a2.444 2.444 0 0 0 .023.33l.008.058H9.54v-.051c-.021-1.624-.495-2.766-1.406-3.395-.963-.664-2.187-.6-3.047-.431l-.184.036.138-.125c.378-.344.77-.537 1.164-.585h2.43a.557.557 0 0 0 .069-.004h.013l.012.005c.198.084.847.413.923 1.145.085.819.475 1.531 1.071 1.955.386.275.774.413 1.155.413a1.618 1.618 0 0 0 .745-.185c.963-.496 1.48-1.824 1.48-2.82 0-.537-.275-1.26-.825-2.147a11.923 11.923 0 0 0-.73-1.065l-.01-.014v-.43l.515-.004a.517.517 0 0 1 .52.481v.016c-.044.179-.168.801.133 1.294a1.2 1.2 0 0 0 .706.518l.024.007.01.023a4.697 4.697 0 0 1 .306 1.708.265.265 0 0 0 .264.264c.388 0 1.255.11 1.758.52l.12.098-.155-.007h-.099a2.393 2.393 0 0 0-2.391 2.392Zm2.39 1.862a1.87 1.87 0 0 1-1.75-1.225v-.012a.26.26 0 0 0-.032-.102l-.005-.011a1.862 1.862 0 1 1 1.789 1.35z"/>
      <path d="M16.618 9.81a1.019 1.019 0 1 0 1.019 1.02 1.02 1.02 0 0 0-1.02-1.02zm0 1.509a.49.49 0 1 1 .49-.49.49.49 0 0 1-.49.49zM8.056 9.233c-.544-.866-1.564-1.192-2.874-.916a.265.265 0 0 0-.207.313.266.266 0 0 0 .313.206 3.725 3.725 0 0 1 .757-.085c.589 0 1.19.176 1.559.765a.267.267 0 0 0 .452-.283Zm.267.749-.009-.005a.264.264 0 0 0-.144-.043.266.266 0 0 0-.222.12.265.265 0 0 0 .077.366l.01.006a.265.265 0 0 0 .402-.275.267.267 0 0 0-.114-.169z"/>
    </g>

    </svg>
  );
}

export const ViagemIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19.9 19.712"
    >

      <g id="layer1" transform="translate(-716.714 -120.946)">
          <g id="g50378-7" fill={fill} transform="matrix(.0688 0 0 .0688 718.063 122.202)">
            <path id="path50362-6" fill={fill} d="M226.05 189.14v-67.21a15.15 15.15 0 0 0-15.14-15.14h-28.35V94.58a15.26 15.26 0 0 0-15.24-15.24H133.8a14.13 14.13 0 0 0-1.46.07v-2.56a15.52 15.52 0 0 0-15.5-15.5h-21.9V46.18h1.9a10.41 10.41 0 0 0 0-20.82H59.45a10.41 10.41 0 1 0 0 20.82h1.89v15.17H39.45A15.51 15.51 0 0 0 24 76.85v111.94a15.5 15.5 0 0 0 6.75 12.78 13.25 13.25 0 1 0 20 2.72h28.84a12.78 12.78 0 1 0 21.24 0h5.27a12.78 12.78 0 1 0 21.24 0h74.84a12.78 12.78 0 1 0 18.08-3.29 15.11 15.11 0 0 0 5.79-11.86zM133.8 85h33.52a9.57 9.57 0 0 1 9.56 9.56v12.1l-5 .07v-6.19a10.9 10.9 0 0 0-10.71-11h-21.25a10.9 10.9 0 0 0-10.71 11v6.19l-5-.07V94.58A9.57 9.57 0 0 1 133.8 85Zm32.43 15.54v6.23h-31.35v-6.23a5.22 5.22 0 0 1 5-5.37h21.32a5.22 5.22 0 0 1 5.03 5.39zM59.45 40.5a4.73 4.73 0 1 1 0-9.46h37.39a4.73 4.73 0 0 1 0 9.46zm29.82 5.68v15.17H67V46.18ZM39.57 219a7.57 7.57 0 0 1-2.18-14.82 15.61 15.61 0 0 0 2.06.15h2.73A7.57 7.57 0 0 1 39.57 219Zm41.17-29.82v-67.25a9.47 9.47 0 0 1 9.47-9.46h2.84v86.14h-2.84a9.48 9.48 0 0 1-9.47-9.47zm9.47 29.35a7.1 7.1 0 1 1 7.1-7.1 7.11 7.11 0 0 1-7.1 7.06zm15.62-19.88h-7.1v-86.18h7.1zm-11.67-91.86V82.18c0-2.48-3.18-4.22-5.68-1.37v26.08a15.17 15.17 0 0 0-13.41 15v67.21a15.06 15.06 0 0 0 3.34 9.47H43a13.19 13.19 0 0 0-3.46-.47 13.62 13.62 0 0 0-2.32.21 9.82 9.82 0 0 1-7.62-9.56V76.85A9.82 9.82 0 0 1 39.45 67h77.39a9.83 9.83 0 0 1 9.82 9.82v4.27a15.26 15.26 0 0 0-8.1 13.46v12.21h-1.37V82.18a2.84 2.84 0 0 0-5.68 0v24.61zm22.56 111.7a7.1 7.1 0 1 1 7.1-7.1 7.11 7.11 0 0 1-7.1 7.1zm73.36-19.88h-78.57v-86.14h78.52zm14.2 0h-8.52v-86.14h8.52zm8.52 19.88a7.1 7.1 0 1 1 7.1-7.1 7.11 7.11 0 0 1-7.1 7.1zm7.57-29.35a9.48 9.48 0 0 1-9.46 9.47H210v-86.14h.95a9.47 9.47 0 0 1 9.46 9.46z"/>
            <path id="path50364-62" fill={fill} d="M128.39 147.78h44.23l-21.79-28.6zm11.68-5.68 10.69-13.63 10.39 13.63z"/>
            <path id="path50366-4" fill={fill} d="M45.25 79.34a2.84 2.84 0 0 0-2.84 2.84v103.65a2.84 2.84 0 0 0 5.68 0V82.18a2.84 2.84 0 0 0-2.84-2.84z"/>
            <path id="path50368-09" fill={fill} d="M68.28 79.34a2.84 2.84 0 0 0-2.84 2.84v103.65a2.84 2.84 0 1 0 5.68 0V82.18a2.84 2.84 0 0 0-2.84-2.84z"/>
          </g>
        </g>

    </svg>
  );
}

export const GarantiaIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 21 21"
    >

      <path fill={fill} d="M10.485 17.996c-4.857-.002-6.843-.014-6.93-.042a1.002 1.002 0 0 1-.296-.213.858.858 0 0 1-.217-.318C3.01 17.313 3 16.199 3 12.722c0-3.477.01-4.592.042-4.7a.854.854 0 0 1 .217-.319.86.86 0 0 1 .318-.217c.1-.03.495-.042 1.31-.042h1.169V5.582c0-1.36.01-1.9.042-2.005a.854.854 0 0 1 .217-.318c.11-.11.227-.19.317-.217C6.741 3.01 7.679 3 10.506 3c3.32 0 3.75.006 3.894.055.109.037.21.11.312.222.082.092.168.23.191.305.031.103.041 1.167.041 4.222v4.085h1.176c.982 0 1.2.009 1.336.055.11.037.211.11.312.222.083.092.169.229.192.305.03.1.041.77.041 2.473 0 1.704-.011 2.373-.041 2.474a1.023 1.023 0 0 1-.192.304.75.75 0 0 1-.312.223c-.146.05-.832.054-6.97.051zm-3.49-.552h3.27l-.02-.078a1.532 1.532 0 0 1-.022-.278v-.2H4.281c-.05 0-.171-.119-.17-.277 0-.157.084-.272.17-.278h5.94v-1.862c0-1.36.012-1.9.042-2.005a.854.854 0 0 1 .217-.318.86.86 0 0 1 .318-.217c.079-.023.231-.042.339-.042h.195v-1.667H3.556v7.052c-.001.079.097.166.17.17zm.432-1.67a2.803 2.803 0 0 1-.469-.05 2.717 2.717 0 0 1-.52-.196 1.942 1.942 0 0 1-.56-.41 1.821 1.821 0 0 1-.408-.557 2.79 2.79 0 0 1-.196-.537 2.769 2.769 0 0 1-.05-.469c0-.124.022-.335.05-.468.028-.134.117-.376.198-.539.111-.222.213-.36.412-.56.207-.208.328-.296.56-.409.164-.079.405-.166.536-.194.131-.028.34-.05.464-.05.125 0 .333.022.465.05.13.028.372.115.535.194.233.113.355.202.565.412.21.21.3.332.412.565.079.163.166.404.194.535.028.131.05.34.05.464s-.022.333-.05.465a2.908 2.908 0 0 1-.195.536c-.115.237-.2.353-.415.566a1.919 1.919 0 0 1-.56.41 2.758 2.758 0 0 1-.532.193c-.134.028-.352.05-.486.05zm.104-.567a1.65 1.65 0 0 0 .486-.09 2.25 2.25 0 0 0 .41-.219c.11-.077.27-.23.354-.342.083-.111.186-.292.227-.402a1.966 1.966 0 0 0 .07-.953 2.032 2.032 0 0 0-.145-.408 1.937 1.937 0 0 0-.307-.411 1.824 1.824 0 0 0-.425-.312 2.085 2.085 0 0 0-.472-.153 1.45 1.45 0 0 0-.512-.005c-.158.023-.348.08-.478.144a2.116 2.116 0 0 0-.365.235l-.15.129.161.078c.089.043.201.114.25.16.048.044.12.144.162.22.067.125.075.192.075.677 0 .485-.007.552-.075.677a1.03 1.03 0 0 1-.163.221 1.22 1.22 0 0 1-.249.16l-.162.078.15.128a1.928 1.928 0 0 0 .723.366c.087.019.282.028.435.022zM5.93 14.18c.021 0 .097-.016.168-.036a.38.38 0 0 0 .182-.112c.04-.057.053-.171.053-.462 0-.333-.01-.4-.068-.474a.449.449 0 0 0-.211-.124l-.143-.036-.055.127c-.036.084-.056.24-.058.458-.002.187.018.4.045.494.026.091.065.165.087.165zm8.181 3.264h3.163c.092-.006.168-.07.17-.17v-4.66c.005-.099-.059-.164-.17-.17h-6.326a.175.175 0 0 0-.17.17v4.66a.17.17 0 0 0 .17.17zm-.833-.555h-1.774c-.079-.002-.167-.09-.17-.17V13.17c0-.082.091-.168.17-.17h3.548a.186.186 0 0 1 .17.17v3.548c-.01.084-.063.164-.17.17zm0-.556h1.389v-2.778h-2.778v2.778zm3.055 0c-.362 0-.39-.005-.47-.085a.28.28 0 0 1-.085-.193.28.28 0 0 1 .085-.192c.08-.08.108-.085.47-.085.363 0 .39.005.47.085a.28.28 0 0 1 .086.192.28.28 0 0 1-.085.193c-.08.08-.108.085-.47.085zm0-1.111c-.362 0-.39-.005-.47-.085a.28.28 0 0 1-.085-.193.28.28 0 0 1 .085-.192c.08-.08.108-.085.47-.085.363 0 .39.005.47.085a.28.28 0 0 1 .086.192.28.28 0 0 1-.085.193c-.08.08-.108.085-.47.085zm0-1.111c-.362 0-.39-.005-.47-.085a.28.28 0 0 1-.085-.193.28.28 0 0 1 .085-.192c.08-.08.108-.086.47-.086.363 0 .39.005.47.086a.28.28 0 0 1 .086.192.28.28 0 0 1-.085.193c-.08.08-.108.085-.47.085zm-3.194-2.222h1.25V9.111h-2.5v2.778zm.417-.556a.28.28 0 0 1-.193-.085c-.085-.085-.085-.09-.085-.748s0-.664.085-.748a.28.28 0 0 1 .193-.085.28.28 0 0 1 .192.085c.085.084.085.09.085.748 0 .657 0 .663-.085.748a.28.28 0 0 1-.192.085zM7.444 9.666h3.89l-.011-1.491s-.007-.15-.16-.175c-.557.004-3.719 0-3.719 0H3.726c-.087.005-.15.058-.157.138l-.014.78v.748zm-2.777-.555c-.363 0-.39-.005-.47-.085a.28.28 0 0 1-.086-.193.28.28 0 0 1 .085-.192c.08-.08.108-.086.47-.086.363 0 .39.005.471.086a.28.28 0 0 1 .085.192.28.28 0 0 1-.085.193c-.08.08-.108.085-.47.085zm2.777 0H5.948c-.084-.004-.17-.156-.17-.278 0-.132.085-.275.17-.278h2.993c.098.001.172.175.17.278-.003.137-.077.278-.17.278zm2.778 0c-.362 0-.39-.005-.47-.085a.28.28 0 0 1-.085-.193.28.28 0 0 1 .085-.192c.08-.08.108-.086.47-.086.363 0 .39.005.47.086a.28.28 0 0 1 .086.192.28.28 0 0 1-.085.193c-.08.08-.108.085-.47.085zm2.917-.556h1.25V3.726c-.002-.084-.075-.16-.17-.17H9.84l-.26.519c-.143.285-.291.535-.328.555-.044.024-.528.036-1.355.036H6.61v2.778h2.286c1.997 0 2.305.007 2.447.055.11.038.211.11.312.223.083.091.169.229.192.304.022.076.04.226.04.334v.195zm.417-1.666a.28.28 0 0 1-.193-.086c-.085-.084-.085-.09-.085-.748 0-.657 0-.663.085-.748a.28.28 0 0 1 .193-.085.28.28 0 0 1 .192.085c.085.085.085.09.085.748s0 .664-.085.748a.28.28 0 0 1-.192.086zM7.774 4.111h1.163l.14-.278.139-.278H6.782l-.086.086c-.07.07-.085.12-.085.277v.193z"/>

    </svg>
  );
}

export const MultiriscosHabitacaoIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 19.135"
    >

      <g fill={fill} transform="translate(2.109 -.324) scale(.07911)">
        <path d="M215.94 106.36A22.12 22.12 0 0 0 200 74a22.09 22.09 0 1 0-39.5 0 22 22 0 0 0-15 9.73L97 51.47a8.46 8.46 0 0 0-9.4 0L61 69.11v-5.57h.26a3.5 3.5 0 0 0 0-7H35a3.5 3.5 0 0 0 0 7h.25v22.71l-22.44 14.88a3.5 3.5 0 0 0 1.94 6.41h11.88v91.75a8.76 8.76 0 0 0 8.75 8.71h112.67a8.76 8.76 0 0 0 8.76-8.75v-42.62h18.44v47.91a3.5 3.5 0 0 0 7 0v-47.91h31.31a25.19 25.19 0 0 0 2.38-50.27zM42.2 63.54H54v10.14h.13L42.2 81.6Zm49.22-6.24a1.48 1.48 0 0 1 1.66 0l65.08 43.24H26.34ZM79.75 201h-27v-58.5h27zm70.06-1.75a1.75 1.75 0 0 1-1.76 1.75h-61.3v-62a3.5 3.5 0 0 0-3.5-3.5h-34a3.5 3.5 0 0 0-3.5 3.5v62H35.38a1.75 1.75 0 0 1-1.75-1.75V108h116.18zm63.75-49.66h-56.75v-42.05h12.94a3.5 3.5 0 0 0 1.94-6.41L151.32 87.6A15 15 0 0 1 164 80.72a15.57 15.57 0 0 1 2.9.27 3.5 3.5 0 0 0 2.62-6.32 14.93 14.93 0 0 1-4.38-10.63 15.09 15.09 0 0 1 30.18 0 14.94 14.94 0 0 1-4.2 10.45 3.5 3.5 0 0 0 2.3 6.51h.38a15.45 15.45 0 0 1 2.72-.24 15.09 15.09 0 0 1 9.25 27l-.1.08a3.5 3.5 0 0 0 3.33 6 18.19 18.19 0 1 1 4.56 35.8z"/>
        <path d="M99.25 176.5h36a3.5 3.5 0 0 0 3.5-3.5v-34a3.5 3.5 0 0 0-3.5-3.5h-36a3.5 3.5 0 0 0-3.5 3.5v34a3.5 3.5 0 0 0 3.5 3.5zm3.5-34h29v27h-29z"/>
        <circle cx="92.25" cy="80.29" r="8"/>
      </g>

    </svg>
  );
}

export const HousekeeperIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 20.126 21"
    >

      <g fill={fill}>
        <path d="M14.955 14.762a.21.21 0 0 0-.024-.042.194.194 0 0 0-.03-.039.25.25 0 0 0-.225-.068.3.3 0 0 0-.047.014.31.31 0 0 0-.043.024.263.263 0 0 0-.038.03.23.23 0 0 0-.03.039.21.21 0 0 0-.024.042.263.263 0 0 0-.019.096.25.25 0 0 0 .25.249.25.25 0 0 0 .049-.005.231.231 0 0 0 .046-.014.258.258 0 0 0 .043-.023.234.234 0 0 0 .038-.031.25.25 0 0 0 .073-.176.263.263 0 0 0-.02-.096zm.905-.361a.31.31 0 0 0-.043-.023.3.3 0 0 0-.046-.014.25.25 0 1 0 .127.42.263.263 0 0 0 .03-.037.27.27 0 0 0 .024-.043.3.3 0 0 0 .012-.048.25.25 0 0 0 .005-.049.25.25 0 0 0-.074-.176.263.263 0 0 0-.034-.03zm-3.648.361a.21.21 0 0 0-.023-.042.194.194 0 0 0-.03-.039.25.25 0 0 0-.226-.068.3.3 0 0 0-.046.014.31.31 0 0 0-.043.024.263.263 0 0 0-.038.03.23.23 0 0 0-.03.039.262.262 0 0 0-.024.042.31.31 0 0 0-.014.047.238.238 0 0 0-.005.049.25.25 0 0 0 .25.249.25.25 0 0 0 .048-.005.231.231 0 0 0 .047-.014.258.258 0 0 0 .042-.023.234.234 0 0 0 .038-.031.25.25 0 0 0 .074-.176.263.263 0 0 0-.02-.096zm.906-.361a.31.31 0 0 0-.043-.023.3.3 0 0 0-.046-.014.243.243 0 0 0-.099 0 .3.3 0 0 0-.046.014.31.31 0 0 0-.043.023.263.263 0 0 0-.038.031.25.25 0 1 0 .353 0 .263.263 0 0 0-.038-.03z"/>
        <path d="M17.127 14.802c-.015-.781-.866-1.413-1.911-1.413a2.244 2.244 0 0 0-1.413.464 2.2 2.2 0 0 0-1.27-.458l.57-3.745h.45a.25.25 0 0 0 .25-.25v-.914a.25.25 0 0 0-.25-.249h-.862v-.902l-1.298-1.298v-.76l.254-.22c.157.31.44.778.839 1.09a.25.25 0 0 0 .307-.391c-.377-.295-.64-.787-.756-1.037l.353-.305h.734a.432.432 0 0 0 .432-.432v-.544a.432.432 0 0 0-.432-.432H10.57a.637.637 0 0 0-.476.213l-1.1 1.226a.455.455 0 0 0 .165.726l.323.132v.794l-.791.791v.108c.012.46.02.965.016 1.24h-.43V6.112l-1.08-1.34v-1.44A.332.332 0 0 0 6.864 3H5.618a.332.332 0 0 0-.333.332V4.86L4.122 6.106v2.131h-.873a.25.25 0 0 0-.249.25V9.4a.25.25 0 0 0 .25.25h.45l1.128 7.433a.25.25 0 0 0 .25.212h5.666c.332.422.946.706 1.646.706a2.244 2.244 0 0 0 1.413-.463 2.244 2.244 0 0 0 1.413.463c1.053 0 1.911-.643 1.911-1.433zM12.64 3.5h.415v.416h-.415zm.664 5.236v.415H9.897v-.415zm-3.9-4.003 1.062-1.186a.143.143 0 0 1 .104-.047h1.571v.468l-1.09.945H9.846zm1.49.679v.478H9.98v-.478zm-.997.977h1.144l1.152 1.152v.696H9.209c0-.212 0-.56-.014-1.146zM9.4 8.736v1.33a.25.25 0 0 0 .073.175l1.589 1.59a.207.207 0 0 1 0 .293.24.24 0 0 1-.326.01l-.92-.802a.25.25 0 0 0-.416.19v2.741a.375.375 0 0 1-.374.374h-.208V12.56a.25.25 0 0 0-.499 0v2.077h-.415V12.56a.25.25 0 0 0-.499 0v2.077h-.498V12.56a.25.25 0 0 0-.499 0v2.077h-.125a.375.375 0 0 1-.373-.374V8.737zM5.784 3.5h.914v1.205h-.914zm-.139 1.704h1.26l.604.748H4.945ZM4.62 6.45h3.158v1.58H4.62zM3.5 9.151v-.415h1.91v.415zm6.98 5.672v1.766a.14.14 0 0 0 0 .019 1.094 1.094 0 0 0 .024.188H5.292L4.205 9.65H5.41v4.612a.873.873 0 0 0 .872.872h2.743a.873.873 0 0 0 .872-.872v-2.195l.51.443a.74.74 0 0 0 1.006-.035.706.706 0 0 0 0-.997L9.897 9.962V9.65H12.6l-.573 3.766c-.882.128-1.547.71-1.547 1.407Zm6.15 1.745c0 .507-.648.935-1.413.935-.499 0-.965-.18-1.221-.47a.25.25 0 0 0-.303-.064.229.229 0 0 0-.083.063c-.256.29-.724.47-1.222.47-.765 0-1.413-.427-1.413-.934v-.78a2.373 2.373 0 0 0 2.826.004 2.373 2.373 0 0 0 2.825-.005zm-1.413-.81c-.499 0-.965-.18-1.221-.47a.25.25 0 0 0-.303-.064.229.229 0 0 0-.083.063c-.256.29-.724.47-1.222.47-.765 0-1.413-.427-1.413-.934s.648-.935 1.413-.935c.499 0 .965.18 1.222.47a.228.228 0 0 0 .053.048.25.25 0 0 0 .325-.043l.008-.009c.257-.288.722-.466 1.217-.466.766 0 1.413.428 1.413.935s-.644.935-1.41.935z"/>
      </g>

    </svg>
  );
}

export const VidaCreditoHabitacaoIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 17.25 18"
    >

      <g fill={fill}>
        <path d="m13.715 4.076-1.926-.004v-.475a.585.585 0 0 0-.584-.586L3.602 3a.585.585 0 0 0-.585.583l-.016 10.802a.585.585 0 0 0 .583.586l7.61.011a.585.585 0 0 0 .585-.583v-.476h1.927a.525.525 0 0 0 .383-.171.574.574 0 0 0 .15-.388l.013-8.73a.55.55 0 0 0-.537-.558Zm-2.45 10.395a.105.105 0 0 1-.072.03l-7.61-.012a.105.105 0 0 1-.074-.03.103.103 0 0 1-.03-.073l.017-10.802a.102.102 0 0 1 .03-.073.103.103 0 0 1 .076-.03l7.61.012a.104.104 0 0 1 .103.103v.717L11.3 14.398a.105.105 0 0 1-.034.073zm2.49-1.105a.092.092 0 0 1-.023.063.041.041 0 0 1-.028.015h-1.927v-1.299h.688a.24.24 0 0 0 0-.481h-.684V10.7h.688a.24.24 0 1 0 0-.482h-.685v-.977h.717a.24.24 0 0 0 0-.481h-.712v-.978h.688a.24.24 0 0 0 0-.482h-.685v-.963h.685a.24.24 0 0 0 0-.482h-.685V4.558l1.927.004c.024 0 .051.033.051.078z"/>
        <path d="M9.896 6.5 7.62 4.982a.394.394 0 0 0-.435 0L4.903 6.496a.24.24 0 0 0 .133.441h.228v2.684a.372.372 0 0 0 .11.267.38.38 0 0 0 .268.112l3.48.004a.378.378 0 0 0 .379-.377l.004-2.683h.26a.24.24 0 0 0 .134-.442zM7.401 5.413l1.567 1.045H5.836zm1.615 4.108-3.274-.005V6.948l3.275.005zm.64 1.683-4.66-.007a.24.24 0 0 0 0 .482l4.66.007a.24.24 0 0 0 0-.482zm0 1.227-4.66-.008a.24.24 0 0 0 0 .482l4.66.008a.24.24 0 0 0 0-.482z"/>
      </g>

    </svg>
  );
}

export const SaudeParticularesIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19.611 18.968"
    >

      <g fill={fill}>
        <path d="M14.993 9.777a.722.722 0 1 0 .722.723.723.723 0 0 0-.722-.723zm0 .963a.24.24 0 1 1 .24-.24.24.24 0 0 1-.24.24z" />
        <path d="M15.268 8.907v-.643a1.968 1.968 0 0 0-3.935 0v4.884a2.385 2.385 0 0 1-4.768 0v-.584h.137a.585.585 0 0 0 .585-.585v-.871a3.4 3.4 0 0 0 2.502-3.276v-.234h-.47V4.342c0-.502-.393-.729-.677-.8a.722.722 0 1 0-.046.488.332.332 0 0 1 .239.312v3.252h-.47v.19c0 1.073-.84 1.984-1.913 2.014a1.972 1.972 0 0 1-2.03-1.966v-.234H3.95v-3.29a.327.327 0 0 1 .229-.306.722.722 0 1 0-.022-.498c-.285.069-.688.296-.688.804v3.286h-.47v.175a3.463 3.463 0 0 0 2.364 3.293v.917a.585.585 0 0 0 .585.585h.138v.584a2.866 2.866 0 0 0 5.731 0V8.264a1.486 1.486 0 0 1 2.972 0v.633a1.617 1.617 0 1 0 .482.01zM7.94 3.964a.24.24 0 1 1 .24-.241.24.24 0 0 1-.24.24zm-3.096-.482a.24.24 0 1 1-.241.24.24.24 0 0 1 .24-.24zM3.483 8.079h.472a2.446 2.446 0 0 0 4.866 0h.47a2.92 2.92 0 0 1-5.819 0zm2.36 3.9v-.796a3.446 3.446 0 0 0 .487.045 3.497 3.497 0 0 0 .475-.025v.776a.103.103 0 0 1-.103.103h-.757a.103.103 0 0 1-.103-.103zm9.15-.344a1.135 1.135 0 1 1 1.135-1.135 1.137 1.137 0 0 1-1.135 1.135z" />
      </g>

    </svg>
  );
}

export const VidaProtecaoIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 19 19"
    >

      <g fill={fill} id="layer1" transform="translate(-463.815 -120.802)"><g id="g45490-2" transform="translate(466.665 123.653) scale(.07473)"><path id="path930-9" d="M48.704 110.458a6.41 6.41 0 0 1 4.59 1.89 3.54 3.54 0 0 0 5-5 13.53 13.53 0 0 0-19.13 0 3.536 3.536 0 0 0 5 5 6.43 6.43 0 0 1 4.57-1.89" class="cls-1"/><path id="path932-2" d="M112.294 107.348a3.54 3.54 0 0 0 5 5 6.46 6.46 0 0 1 9.13 0 3.54 3.54 0 0 0 5-5 13.55 13.55 0 0 0-19.13 0" class="cls-1"/><path id="path934-2" d="M121.864 142.208a51.77 51.77 0 0 1-73.14 0 3.536 3.536 0 0 0-5 5 58.83 58.83 0 0 0 83.12 0 3.536 3.536 0 0 0-5-5" class="cls-1"/><path id="path936-15" d="M168.664 114.268a19.62 19.62 0 0 0-16.05-19.27v-59.12a22.83 22.83 0 0 0-30.41-21.53l-22.18-7.53a88.1 88.1 0 0 0-51.89-1.72c-22.13 6.11-34.84 19.02-36.77 37.37a26.79 26.79 0 0 0-4 7.62l-1.72 5.1a6.13 6.13 0 0 0 10.08 6.37 12.31 12.31 0 0 1 2.29-1.75v35.19a19.59 19.59 0 0 0 1.07 38.69 67.87 67.87 0 0 0 18.55 35.65 66.5 66.5 0 0 0 47.66 20 67.34 67.34 0 0 0 66.32-55.65 19.63 19.63 0 0 0 17.05-19.43m-30.17-91.5a15.49 15.49 0 0 1 7.05 13.12v46.25a23 23 0 0 1-19.4-22.66l-.29-38.85a15.49 15.49 0 0 1 12.64 2.14m-125.2 31.63.68-2a19.79 19.79 0 0 1 27.11-11.6 27 27 0 0 0 31.46-6.56l.87-1a3.535 3.535 0 0 0-5.29-4.69l-.88 1a19.89 19.89 0 0 1-23.17 4.83 26.92 26.92 0 0 0-21.92-.34c-.64.27-1.26.58-1.87.89 4.11-11 14-18.66 29.69-23a80.87 80.87 0 0 1 47.74 1.6l21 7.14.27 18.25a62.42 62.42 0 0 1-84.3 15.28 19.13 19.13 0 0 0-21.39.2m-4.35 59.88a12.55 12.55 0 0 1 9-12v19.15c0 1.66.06 3.3.18 4.94a12.56 12.56 0 0 1-9.17-12.07m118.94 50.4a59.85 59.85 0 0 1-42.6 17.63 59.48 59.48 0 0 1-42.62-17.92 60.88 60.88 0 0 1-17.63-43v-63.26a12.22 12.22 0 0 1 5.78 2 69.54 69.54 0 0 0 88.26-10.25v9.58a30 30 0 0 0 26.46 29.78v32.82a59.84 59.84 0 0 1-17.65 42.62m24.58-38.34c.09-1.42.14-2.83.14-4.26v-19.84a12.53 12.53 0 0 1-.14 24.08" class="cls-1"/></g></g>

    </svg>
  );
}

export const AutoEmpresasIcon = (
  {
    fill,
    size,
    className
  }
) => {
  return(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 512 512"
    >

      <path fill={fill} d="m343.5 137.875 3.5.015c3.27.021 6.541.051 9.812.087 2.304.024 4.608.043 6.912.061 4.162.036 8.323.097 12.484.172 1.628.026 3.255.047 4.883.06 14.31.134 27.228 2.522 40.596 7.792l1.967.737c3.678 1.41 7.17 2.854 10.346 5.201.813 3.688.813 3.688 1 7-1.52 1.129-1.52 1.129-4 2a65.957 65.957 0 0 1-7.688-2.063l-4.562-1.425-2.367-.757c-3.842-1.218-7.705-2.362-11.57-3.505l-2.103-.637c-5.963-1.778-11.535-2.733-17.756-2.774l-3.55-.03-3.799-.012-3.945-.017c-2.75-.01-5.502-.017-8.253-.02-3.503-.006-7.006-.03-10.51-.058-3.368-.023-6.736-.025-10.104-.03l-3.78-.038c-9.973.026-17.794 1.147-25.013 8.366a150.192 150.192 0 0 0-3 5l2.44.025c7.69.078 15.38.166 23.07.263 3.951.049 7.902.095 11.853.134 68.74.682 68.74.682 84.637 16.578-.375 3.625-.375 3.625-1 7-5.974-.21-10.768-1.552-16.25-3.875-13.441-5.666-26.87-7.104-41.313-7.688L366 175v44l13.352-.07c3.522-.013 7.044-.024 10.567-.034 3.713-.01 7.426-.024 11.14-.047 3.578-.022 7.157-.034 10.736-.039 1.363-.003 2.726-.01 4.088-.021 1.915-.015 3.83-.016 5.744-.016l3.298-.014c3.433.269 7.527.693 10.075 3.241.125 3 .125 3 0 6-1.998 1.998-5.88 1.418-8.617 1.555l-2.516.127c-11.944.533-23.902.468-35.856.448-3.45-.005-6.9-.002-10.35.004-33.503.047-33.503.047-41.661-1.134-2-2-2-2-2.375-4.438C334 222 334 222 338 219h18v-44h-51l-2 5a211.682 211.682 0 0 1-3.23 5.754l-1.936 3.342-2.022 3.466-1.962 3.385A5582.862 5582.862 0 0 1 288 206l-1.025 1.759L281 218l3.026.06c3.724.076 7.447.165 11.17.257 1.609.039 3.217.073 4.825.105 2.319.046 4.637.104 6.956.164l2.16.035c4.297.125 7.859.818 11.863 2.379.688 2.313.688 2.313 1 5-1.598 2.253-2.547 2.922-5.287 3.392l-2.759.025-3.207.05-3.571.01-3.844.045c-2.827.034-5.654.057-8.482.074-4.61.027-9.22.078-13.829.131-17.665.193-35.33.284-52.997.357-6.773.028-13.546.059-20.32.096l-2.045.012-8.197.046c-8.182.047-16.364.082-24.547.094-5.846.01-11.691.04-17.537.076-2.43.012-4.86.017-7.29.014-3.36-.002-6.72.02-10.08.048l-2.949-.02c-9.393.127-16.903 2.792-23.684 9.378C110 241 110 241 108 241l-.879 1.797c-.945 1.857-1.991 3.663-3.058 5.453-3.23 6.388-3.935 13.751-5.063 20.75l-1 6 1.688.625c4.619 2.747 7.983 7.18 9.312 12.375.285 4.243.352 7.943-1 12l13 1 2-6c1.442-2.26 2.864-4.333 4.5-6.438l1.335-1.722c4.057-5.035 8.557-8.607 14.165-11.84l1.914-1.2c11.402-6.525 25.604-7.164 38.125-4.042C196.736 274.349 207.684 282.545 215 295c5.844 12.094 6 19.608 6 34l111-1-8-10c-6.761-13.229-9.55-25.765-4.969-40.379C324.264 263.462 332.554 254.91 346 248c11.176-4.785 23.899-4.157 35.832-4.168l3.867-.01c2.676-.005 5.353-.008 8.03-.007 3.413 0 6.826-.014 10.24-.031 3.288-.014 6.575-.013 9.863-.014l3.687-.022c14.267.038 14.267.038 17.481 3.252.125 3 .125 3 0 6-4.559 4.559-21.248 2.195-27.418 2.246l-4.054.049c-5.673.07-11.346.13-17.019.182-3.496.032-6.991.073-10.487.12-1.952.023-3.905.037-5.857.05-12.754.176-22.86 2.183-32.278 11.427-7.111 8.481-9.63 17.518-9.27 28.496 1.155 10.346 5.849 18.093 13.258 25.18 8.684 6.253 16.495 7.33 27 7.813l2.664.13A2327 2327 0 0 0 378 329v-3l-2.813-.188C372 325 372 325 370.325 322.817c-2.76-5.869-1.994-12.544-.199-18.628 3.858-6.559 6.967-10.339 14.348-12.61 4.297-.983 8.5-.986 12.89-.941l2.892-.002c2.001.003 4.002.012 6.003.029 3.063.024 6.126.02 9.19.014 1.95.005 3.902.012 5.853.021l2.768-.003 2.58.03 2.26.013c2.379.297 4.02 1.083 6.091 2.261.125 2.875.125 2.875 0 6-4.282 4.282-11.654 3.134-17.379 3.14l-5.478.06c-2.86.028-5.719.05-8.578.05-2.774.004-5.546.038-8.319.078l-2.582-.021c-4.212.086-6.135.305-9.617 2.86-2.105 2.913-3.16 5.366-4.047 8.833l1.985.004c6.814.02 13.626.074 20.44.149 2.543.023 5.086.037 7.63.043a1056 1056 0 0 1 10.96.097l3.451-.012c7.916.147 7.916.147 11.283 3.263L436 320c-.813 2.438-.813 2.438-2 5-3.619 1.206-6.925 1.108-10.688 1.063l-2.126-.014c-1.729-.012-3.458-.03-5.186-.049l1.5 2.375C419 331 419 331 419 333c3.78 2.04 7.631 3.092 11.758 4.219C433 338 433 338 435 340c.125 3.125.125 3.125 0 6-4.555 2.614-8.006 2.317-13 1-6.916-3.006-12.48-7.233-16-14l-2-7h-15c3.486 10.952 3.486 10.952 9.766 20.45C400 348 400 348 401 351c1.823 1.063 1.823 1.063 4 2 1.502.977 3.002 1.956 4.5 2.938 5.594 3.396 11.155 4.718 17.5 6.062 2.346.63 4.67 1.312 7 2 .688 2.813.688 2.813 1 6-1.438 2.317-2.556 2.86-5.137 3.676-3.745.424-6.957-.351-10.55-1.301l-2.156-.566c-14.641-4.02-24.979-12.34-32.915-25.364C383 344 383 344 382 340H218l-2 5c-8.62 14.535-19.4 22.715-35.492 27.785-12.283 3.04-25.947.722-36.758-5.723C142 365 142 365 141.562 362.375 142 360 142 360 144 358c4.171-.426 7.423.03 11.313 1.438 10.581 3.753 21.557 3.145 31.812-1.5 10.27-5.68 16.6-13.037 20.875-23.938 3.059-10.678 1.97-24.148-3-34-5.855-9.878-14.868-16.1-25.793-19.34-11.901-2.45-22.06-.362-32.457 5.652C136.916 292.95 131.79 301.52 129 313c-1.092 10.961.452 18.95 5 29a160.324 160.324 0 0 1 1.938 5.125l.777 2.07C137 351 137 351 135 354c-1.75 1-1.75 1-4 1-4.382-2.797-5.967-4.816-7.762-9.637-1.201-2.486-1.201-2.486-3.238-4.363-4.928-1.259-9.825-1.081-14.875-.938-2.685.028-5.37.032-8.055.036l-3.6.078c-4.882-.248-9.013-.987-12.845-4.113-2.577-3.272-2.753-5.997-2.77-10.022l-.02-3.054-.003-3.296-.01-3.388c-.005-2.367-.007-4.733-.007-7.1-.002-3.623-.02-7.246-.04-10.869-.003-2.298-.005-4.595-.005-6.893l-.022-3.289.01-3.064-.005-2.691c.268-2.596.864-4.196 2.247-6.397 1.945-1.266 1.945-1.266 4.125-2.25l2.195-1.016L88 272l.078-3.332c.476-14.133 3.147-24.86 12.922-35.668 3.455-3.073 7.056-5.594 11-8l2.48-1.566c5.386-2.93 10.495-3.813 16.556-4.057l2.47-.113c11.947-.482 23.909-.391 35.864-.365 3.48.006 6.96.006 10.441.008 6.559.003 13.117.01 19.676.021 7.48.011 14.96.017 22.44.022 15.358.01 30.716.028 46.073.05l.896-2.303c1.361-3.324 3.078-6.396 4.854-9.51l1.17-2.065c5.36-9.42 10.829-18.778 16.322-28.121a1423.97 1423.97 0 0 0 5.008-8.634C310.73 143.431 310.73 143.431 326 139c5.78-1.34 11.6-1.151 17.5-1.125ZM88 285a184.94 184.94 0 0 0-.063 7.563l.014 2.154c.012 1.76.03 3.522.049 5.283 2.362.681 2.362.681 5 1 2.861-1.971 4.655-3.494 5.453-6.977.182-3.46-.201-5.65-2.14-8.523-2.566-1.664-5.822-2.991-8.313-.5Zm1 28c-2.39 4.78-1 10.656-1 16h29v-17c-4.104-.027-8.208-.047-12.313-.063l-3.537-.025-3.388-.01-3.127-.016c-2.744-.002-2.744-.002-5.635 1.114Z"/>
      <path fill={fill} d="M183 297c6.93 4.813 11.322 10.608 13 19 .725 7.774-.084 13.958-4.7 20.355-5.199 6.262-10.983 10.813-19.3 11.645-8.052.528-13.812-.991-20.188-6.063-6.62-6.28-9.094-12.452-9.375-21.562.347-9.065 2.896-14.67 9.524-20.832 8.91-6.742 21.193-8.113 31.039-2.543Zm-27.813 14.188c-2.25 5.328-2.904 10.491-1.125 16.062 2.01 4.62 5.143 7.539 9.813 9.563 6.956.71 6.956.71 13.375-1.5 3.676-3.092 7.322-6.448 8.059-11.38.327-6.33-.96-9.964-4.606-15.12-2.648-2.819-4.671-3.69-8.508-4.149-7.53-.096-11.983.46-17.007 6.524Z"/>
      <path fill={fill} d="M218.563 246.625C221 247 221 247 223 249c.259 2.49.259 2.49.266 5.594l.007 3.37-.023 3.536.023 3.535-.007 3.371-.007 3.104C223 274 223 274 221 276c-3.563-.25-3.563-.25-7-1-1.932-3.864-1.228-8.624-1.25-12.875l-.063-3.05-.015-2.942-.028-2.691c.569-3.9 1.924-6.232 5.918-6.817Z"/>
      <path fill={fill} d="M198.563 247.188C201 248 201 248 203 251c.266 2.813.266 2.813.25 6l.016 3.188C203 263 203 263 201 266c-3 .313-3 .313-6 0-2.483-2.483-2.286-4.012-2.322-7.41l.01-2.09-.05-2.09c-.001-2.004-.001-2.004.362-5.41 3-2 3-2 5.563-1.813ZM175 247c3.297.33 4.623.623 7 3-.33 3.297-.623 4.623-3 7-3.297-.33-4.623-.623-7-3 .33-3.297.623-4.623 3-7Z"/>

    </svg>
  );
}

export const ArrowSendIcon = (
  {
    fill,
    size,
    className,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      viewBox="0 0 64 64"
    >
      <path fill={fill} d="M1.3 2.7C.6 3 0 3.7 0 4.2c0 .6 4.5 7.1 10 14.5L20 32 10 45.3C4.5 52.7 0 59.1 0 59.7c0 .6.6 1.3 1.3 1.6 1.4.5 59.8-26 61.9-28.1.9-.9.9-1.5-.2-2.6-.8-.7-12.5-6.4-26-12.6C3.5 2.6 2.7 2.2 1.3 2.7z"/>
    </svg>
  );
}

export const CloseButtonIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 17 17"
    >
      <g fill={fill}>
        <path d="m15.736 3.09-12.706 12a1.5 1.5 0 0 1-2.06-2.18l12.706-12a1.5 1.5 0 1 1 2.06 2.18Z"/>
        <path d="m.97 3.09 12.706 12a1.5 1.5 0 0 0 2.06-2.18L3.03.91A1.5 1.5 0 1 0 .97 3.09Z"/>
      </g>
    </svg>
  );
}

export const DevModeButtonIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 200 200"
    >
      <path fill={fill} d="M89.329 11.618c-13.24 1.615-26.193 6.31-37.4 13.626C37.245 34.757 25.492 48.718 18.64 64.82a88.513 88.513 0 0 0-6.792 27.409 91.529 91.529 0 0 0-.303 6.403 89.41 89.41 0 0 0 1.83 19.127 88.232 88.232 0 0 0 6.1 18.695 88.696 88.696 0 0 0 13.045 20.587 89.509 89.509 0 0 0 16.355 15.045 89.352 89.352 0 0 0 9.066 5.664 88.593 88.593 0 0 0 8.903 4.216 88.23 88.23 0 0 0 14.152 4.409 88.742 88.742 0 0 0 14.104 1.942c2.165.128 4.36.162 6.472.137a90.599 90.599 0 0 0 12.147-1.013 92.694 92.694 0 0 0 4.484-.808 87.847 87.847 0 0 0 15.713-4.809 88.382 88.382 0 0 0 12.901-6.601 88.3 88.3 0 0 0 5.923-4.009 89.565 89.565 0 0 0 10.861-9.451 89.928 89.928 0 0 0 7.294-8.465l-21.23-12.494c-8.384 10.172-19.981 17.655-32.726 21.04-14.59 3.916-30.555 2.508-44.197-4.003-12.634-5.959-23.196-16.169-29.593-28.585-5.81-11.167-8.158-24.066-6.784-36.57 1.361-12.844 6.77-25.21 15.249-34.95C60.612 47.3 73.042 39.882 86.51 36.961a63.667 63.667 0 0 1 3.499-.667V11.538l-.681.08zm21.256 24.677c13.218 2.11 25.696 8.503 35.158 17.967 9.374 9.298 15.77 21.557 17.952 34.584 1.675 9.736 1.032 19.85-1.836 29.301a69.524 69.524 0 0 1-1.28 3.865l21.245 12.5a88.116 88.116 0 0 0 6.028-20.371 85.71 85.71 0 0 0 .85-6.595c.441-4.87.467-9.754.094-14.678a90.133 90.133 0 0 0-.68-6.119c-1.213-8.251-3.634-16.494-7.172-24.126a91.45 91.45 0 0 0-3.293-6.451 230.44 230.44 0 0 1-.994-1.717c-7.825-13.173-19.097-24.27-32.404-31.866a88.266 88.266 0 0 0-33.668-11.05v24.756z" opacity="1"/>
    </svg>
  );
}

export const DashboardCalendarIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M16 14v2.2l1.6 1M16 2v4M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5M3 10h5M8 2v4"/>
      <circle fill="none" cx="16" cy="16" r="6"/>
    </svg>
  );
}

export const DashboardArrowIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  );
}

export const DashboardClockIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <circle fill="none" cx="12" cy="12" r="10"/>
      <path fill="none" d="M12 6v6l4 2"/>
    </svg>
  );
}

export const DashboardWarningIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4M12 17h.01"/>
    </svg>
  );
}

export const DashboardShieldIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
      <path fill="none" d="m9 12 2 2 4-4"/>
    </svg>
  );
}

export const DashboardUpwardsTrendIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M16 7h6v6"/>
      <path fill="none" d="m22 7-8.5 8.5-5-5L2 17"/>
    </svg>
  );
}

export const DashboardDownwardsTrendIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M16 17h6v-6"/>
      <path fill="none" d="m22 17-8.5-8.5-5 5L2 7"/>
    </svg>
  );
}

export const DashboardLifeIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/>
      <path fill="none" d="M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"/>
    </svg>
  );
}

export const DashboardFinanceIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M3 3v16a2 2 0 0 0 2 2h16"/>
      <path fill="none" d="m19 9-5 5-4-4-3 3"/>
    </svg>
  );
}

export const DashboardUpdateIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path fill="none" d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
      <path fill="none" d="M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
      <path fill="none" d="M8 16H3v5"/>
    </svg>
  );
}

export const CheckIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M20 6 9 17l-5-5" transform="translate(12,12) scale(0.75) translate(-12,-12)"/>
    </svg>
  );
}

export const CrossIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M18 6 6 18" transform="translate(12,12) scale(0.75) translate(-12,-12)"/>
      <path fill="none" d="m6 6 12 12" transform="translate(12,12) scale(0.75) translate(-12,-12)"/>
    </svg>
  );
}

export const InfoIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle fill="none" cx="12" cy="12" r="10"/>
      <path d="M12 16v-4"/>
      <path d="M12 8h.01"/>
    </svg>
  );
}

export const EditIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/>
      <path fill="none" d="m15 5 4 4"/>
    </svg>
  );
}

export const UploadIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M12 3v12"/>
      <path fill="none" d="m17 8-5-5-5 5"/>
      <path fill="none" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    </svg>
  );
}

export const DownloadIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M12 15V3"/>
      <path fill="none" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <path fill="none" d="m7 10 5 5 5-5"/>
    </svg>
  );
}

export const AddPersonIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
      <circle fill="none" cx="9" cy="7" r="4"/>
      <line fill="none" x1="19" x2="19" y1="8" y2="14"/>
      <line fill="none" x1="22" x2="16" y1="11" y2="11"/>
    </svg>
  );
}

export const AddInsuranceIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M16 10a4 4 0 0 1-8 0"/>
      <path fill="none" d="M3.103 6.034h17.794"/>
      <path fill="none" d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/>
    </svg>
  );
}

export const DashboardIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect fill="none" width="7" height="7" x="3" y="3" rx="1"/>
      <rect fill="none" width="7" height="7" x="14" y="3" rx="1"/>
      <rect fill="none" width="7" height="7" x="14" y="14" rx="1"/>
      <rect fill="none" width="7" height="7" x="3" y="14" rx="1"/>
    </svg>
  );
}

export const CalendarIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M8 2v4"/>
      <path fill="none" d="M16 2v4"/>
      <rect fill="none" width="18" height="18" x="3" y="4" rx="2"/>
      <path fill="none" d="M3 10h18"/>
      <path fill="none" d="M8 14h.01"/>
      <path fill="none" d="M12 14h.01"/>
      <path fill="none" d="M16 14h.01"/>
      <path fill="none" d="M8 18h.01"/>
      <path fill="none" d="M12 18h.01"/>
      <path fill="none" d="M16 18h.01"/>
    </svg>
  );
}

export const PaperIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
      <path fill="none" d="M14 2v5a1 1 0 0 0 1 1h5"/>
      <path fill="none" d="M10 9H8"/>
      <path fill="none" d="M16 13H8"/>
      <path fill="none" d="M16 17H8"/>
    </svg>
  );
}

export const ShieldWarningIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
      <path fill="none" d="M12 8v4"/>
      <path fill="none" d="M12 16h.01"/>
    </svg>
  );
}

export const PaperMoneyIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/>
      <path fill="none" d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
      <path fill="none" d="M12 17.5v-11"/>
    </svg>
  );
}

export const ConfigurationsIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"/>
      <circle fill="none" cx="12" cy="12" r="3"/>
    </svg>
  );
}

export const MenuIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M4 6h16"/>
      <path fill="none" d="M4 12h16"/>
      <path fill="none" d="M4 18h16"/>
    </svg>
  );
}

export const ExitIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="m16 17 5-5-5-5"/>
      <path fill="none" d="M21 12H9"/>
      <path fill="none" d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    </svg>
  );
}

export const MessageIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/>
    </svg>
  );
}

export const EyeIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
      <circle fill="none" cx="12" cy="12" r="3"/>
    </svg>
  );
}

export const ChevronDownIcon = (
  {
    fill,
    size,
    className,
    id,
    onClick
  }
) => {
  return(
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      className={className}
      id={id}
      viewBox="0 0 24 24"
      stroke={fill}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path fill="none" d="m6 9 6 6 6-6"/>
    </svg>
  );
}
